const emojis = [
  {
    title: 't(Smileys & People)',
    emojis: [
      {
        skin: false,
        name: 'grinning',
        code: '1f600',
        aliases: []
      },
      {
        skin: false,
        name: 'grin',
        code: '1f601',
        aliases: []
      },
      {
        skin: false,
        name: 'joy',
        code: '1f602',
        aliases: []
      },
      {
        skin: false,
        name: 'rolling_on_the_floor_laughing',
        code: '1f923',
        aliases: []
      },
      {
        skin: false,
        name: 'smiley',
        code: '1f603',
        aliases: []
      },
      {
        skin: false,
        name: 'smile',
        code: '1f604',
        aliases: []
      },
      {
        skin: false,
        name: 'sweat_smile',
        code: '1f605',
        aliases: []
      },
      {
        skin: false,
        name: 'laughing',
        code: '1f606',
        aliases: [
          'satisfied'
        ]
      },
      {
        skin: false,
        name: 'wink',
        code: '1f609',
        aliases: []
      },
      {
        skin: false,
        name: 'blush',
        code: '1f60a',
        aliases: []
      },
      {
        skin: false,
        name: 'yum',
        code: '1f60b',
        aliases: []
      },
      {
        skin: false,
        name: 'sunglasses',
        code: '1f60e',
        aliases: []
      },
      {
        skin: false,
        name: 'heart_eyes',
        code: '1f60d',
        aliases: []
      },
      {
        skin: false,
        name: 'kissing_heart',
        code: '1f618',
        aliases: []
      },
      {
        skin: false,
        name: 'kissing',
        code: '1f617',
        aliases: []
      },
      {
        skin: false,
        name: 'kissing_smiling_eyes',
        code: '1f619',
        aliases: []
      },
      {
        skin: false,
        name: 'kissing_closed_eyes',
        code: '1f61a',
        aliases: []
      },
      {
        skin: false,
        name: 'relaxed',
        code: '263a-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'slightly_smiling_face',
        code: '1f642',
        aliases: []
      },
      {
        skin: false,
        name: 'hugging_face',
        code: '1f917',
        aliases: []
      },
      {
        skin: false,
        name: 'star-struck',
        code: '1f929',
        aliases: [
          'grinning_face_with_star_eyes'
        ]
      },
      {
        skin: false,
        name: 'thinking_face',
        code: '1f914',
        aliases: []
      },
      {
        skin: false,
        name: 'face_with_raised_eyebrow',
        code: '1f928',
        aliases: [
          'face_with_one_eyebrow_raised'
        ]
      },
      {
        skin: false,
        name: 'neutral_face',
        code: '1f610',
        aliases: []
      },
      {
        skin: false,
        name: 'expressionless',
        code: '1f611',
        aliases: []
      },
      {
        skin: false,
        name: 'no_mouth',
        code: '1f636',
        aliases: []
      },
      {
        skin: false,
        name: 'face_with_rolling_eyes',
        code: '1f644',
        aliases: []
      },
      {
        skin: false,
        name: 'smirk',
        code: '1f60f',
        aliases: []
      },
      {
        skin: false,
        name: 'persevere',
        code: '1f623',
        aliases: []
      },
      {
        skin: false,
        name: 'disappointed_relieved',
        code: '1f625',
        aliases: []
      },
      {
        skin: false,
        name: 'open_mouth',
        code: '1f62e',
        aliases: []
      },
      {
        skin: false,
        name: 'zipper_mouth_face',
        code: '1f910',
        aliases: []
      },
      {
        skin: false,
        name: 'hushed',
        code: '1f62f',
        aliases: []
      },
      {
        skin: false,
        name: 'sleepy',
        code: '1f62a',
        aliases: []
      },
      {
        skin: false,
        name: 'tired_face',
        code: '1f62b',
        aliases: []
      },
      {
        skin: false,
        name: 'sleeping',
        code: '1f634',
        aliases: []
      },
      {
        skin: false,
        name: 'relieved',
        code: '1f60c',
        aliases: []
      },
      {
        skin: false,
        name: 'stuck_out_tongue',
        code: '1f61b',
        aliases: []
      },
      {
        skin: false,
        name: 'stuck_out_tongue_winking_eye',
        code: '1f61c',
        aliases: []
      },
      {
        skin: false,
        name: 'stuck_out_tongue_closed_eyes',
        code: '1f61d',
        aliases: []
      },
      {
        skin: false,
        name: 'drooling_face',
        code: '1f924',
        aliases: []
      },
      {
        skin: false,
        name: 'unamused',
        code: '1f612',
        aliases: []
      },
      {
        skin: false,
        name: 'sweat',
        code: '1f613',
        aliases: []
      },
      {
        skin: false,
        name: 'pensive',
        code: '1f614',
        aliases: []
      },
      {
        skin: false,
        name: 'confused',
        code: '1f615',
        aliases: []
      },
      {
        skin: false,
        name: 'upside_down_face',
        code: '1f643',
        aliases: []
      },
      {
        skin: false,
        name: 'money_mouth_face',
        code: '1f911',
        aliases: []
      },
      {
        skin: false,
        name: 'astonished',
        code: '1f632',
        aliases: []
      },
      {
        skin: false,
        name: 'white_frowning_face',
        code: '2639-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'slightly_frowning_face',
        code: '1f641',
        aliases: []
      },
      {
        skin: false,
        name: 'confounded',
        code: '1f616',
        aliases: []
      },
      {
        skin: false,
        name: 'disappointed',
        code: '1f61e',
        aliases: []
      },
      {
        skin: false,
        name: 'worried',
        code: '1f61f',
        aliases: []
      },
      {
        skin: false,
        name: 'triumph',
        code: '1f624',
        aliases: []
      },
      {
        skin: false,
        name: 'cry',
        code: '1f622',
        aliases: []
      },
      {
        skin: false,
        name: 'sob',
        code: '1f62d',
        aliases: []
      },
      {
        skin: false,
        name: 'frowning',
        code: '1f626',
        aliases: []
      },
      {
        skin: false,
        name: 'anguished',
        code: '1f627',
        aliases: []
      },
      {
        skin: false,
        name: 'fearful',
        code: '1f628',
        aliases: []
      },
      {
        skin: false,
        name: 'weary',
        code: '1f629',
        aliases: []
      },
      {
        skin: false,
        name: 'exploding_head',
        code: '1f92f',
        aliases: [
          'shocked_face_with_exploding_head'
        ]
      },
      {
        skin: false,
        name: 'grimacing',
        code: '1f62c',
        aliases: []
      },
      {
        skin: false,
        name: 'cold_sweat',
        code: '1f630',
        aliases: []
      },
      {
        skin: false,
        name: 'scream',
        code: '1f631',
        aliases: []
      },
      {
        skin: false,
        name: 'flushed',
        code: '1f633',
        aliases: []
      },
      {
        skin: false,
        name: 'zany_face',
        code: '1f92a',
        aliases: [
          'grinning_face_with_one_large_and_one_small_eye'
        ]
      },
      {
        skin: false,
        name: 'dizzy_face',
        code: '1f635',
        aliases: []
      },
      {
        skin: false,
        name: 'rage',
        code: '1f621',
        aliases: []
      },
      {
        skin: false,
        name: 'angry',
        code: '1f620',
        aliases: []
      },
      {
        skin: false,
        name: 'face_with_symbols_on_mouth',
        code: '1f92c',
        aliases: [
          'serious_face_with_symbols_covering_mouth'
        ]
      },
      {
        skin: false,
        name: 'mask',
        code: '1f637',
        aliases: []
      },
      {
        skin: false,
        name: 'face_with_thermometer',
        code: '1f912',
        aliases: []
      },
      {
        skin: false,
        name: 'face_with_head_bandage',
        code: '1f915',
        aliases: []
      },
      {
        skin: false,
        name: 'nauseated_face',
        code: '1f922',
        aliases: []
      },
      {
        skin: false,
        name: 'face_vomiting',
        code: '1f92e',
        aliases: [
          'face_with_open_mouth_vomiting'
        ]
      },
      {
        skin: false,
        name: 'sneezing_face',
        code: '1f927',
        aliases: []
      },
      {
        skin: false,
        name: 'innocent',
        code: '1f607',
        aliases: []
      },
      {
        skin: false,
        name: 'face_with_cowboy_hat',
        code: '1f920',
        aliases: []
      },
      {
        skin: false,
        name: 'clown_face',
        code: '1f921',
        aliases: []
      },
      {
        skin: false,
        name: 'lying_face',
        code: '1f925',
        aliases: []
      },
      {
        skin: false,
        name: 'shushing_face',
        code: '1f92b',
        aliases: [
          'face_with_finger_covering_closed_lips'
        ]
      },
      {
        skin: false,
        name: 'face_with_hand_over_mouth',
        code: '1f92d',
        aliases: [
          'smiling_face_with_smiling_eyes_and_hand_covering_mouth'
        ]
      },
      {
        skin: false,
        name: 'face_with_monocle',
        code: '1f9d0',
        aliases: []
      },
      {
        skin: false,
        name: 'nerd_face',
        code: '1f913',
        aliases: []
      },
      {
        skin: false,
        name: 'smiling_imp',
        code: '1f608',
        aliases: []
      },
      {
        skin: false,
        name: 'imp',
        code: '1f47f',
        aliases: []
      },
      {
        skin: false,
        name: 'japanese_ogre',
        code: '1f479',
        aliases: []
      },
      {
        skin: false,
        name: 'japanese_goblin',
        code: '1f47a',
        aliases: []
      },
      {
        skin: false,
        name: 'skull',
        code: '1f480',
        aliases: []
      },
      {
        skin: false,
        name: 'skull_and_crossbones',
        code: '2620-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'ghost',
        code: '1f47b',
        aliases: []
      },
      {
        skin: false,
        name: 'alien',
        code: '1f47d',
        aliases: []
      },
      {
        skin: false,
        name: 'space_invader',
        code: '1f47e',
        aliases: []
      },
      {
        skin: false,
        name: 'robot_face',
        code: '1f916',
        aliases: []
      },
      {
        skin: false,
        name: 'hankey',
        code: '1f4a9',
        aliases: [
          'poop',
          'shit'
        ]
      },
      {
        skin: false,
        name: 'smiley_cat',
        code: '1f63a',
        aliases: []
      },
      {
        skin: false,
        name: 'smile_cat',
        code: '1f638',
        aliases: []
      },
      {
        skin: false,
        name: 'joy_cat',
        code: '1f639',
        aliases: []
      },
      {
        skin: false,
        name: 'heart_eyes_cat',
        code: '1f63b',
        aliases: []
      },
      {
        skin: false,
        name: 'smirk_cat',
        code: '1f63c',
        aliases: []
      },
      {
        skin: false,
        name: 'kissing_cat',
        code: '1f63d',
        aliases: []
      },
      {
        skin: false,
        name: 'scream_cat',
        code: '1f640',
        aliases: []
      },
      {
        skin: false,
        name: 'crying_cat_face',
        code: '1f63f',
        aliases: []
      },
      {
        skin: false,
        name: 'pouting_cat',
        code: '1f63e',
        aliases: []
      },
      {
        skin: false,
        name: 'see_no_evil',
        code: '1f648',
        aliases: []
      },
      {
        skin: false,
        name: 'hear_no_evil',
        code: '1f649',
        aliases: []
      },
      {
        skin: false,
        name: 'speak_no_evil',
        code: '1f64a',
        aliases: []
      },
      {
        skin: true,
        name: 'baby',
        code: '1f476',
        aliases: []
      },
      {
        skin: true,
        name: 'child',
        code: '1f9d2',
        aliases: []
      },
      {
        skin: true,
        name: 'boy',
        code: '1f466',
        aliases: []
      },
      {
        skin: true,
        name: 'girl',
        code: '1f467',
        aliases: []
      },
      {
        skin: true,
        name: 'adult',
        code: '1f9d1',
        aliases: []
      },
      {
        skin: true,
        name: 'man',
        code: '1f468',
        aliases: []
      },
      {
        skin: true,
        name: 'woman',
        code: '1f469',
        aliases: []
      },
      {
        skin: true,
        name: 'older_adult',
        code: '1f9d3',
        aliases: []
      },
      {
        skin: true,
        name: 'older_man',
        code: '1f474',
        aliases: []
      },
      {
        skin: true,
        name: 'older_woman',
        code: '1f475',
        aliases: []
      },
      {
        skin: true,
        name: 'male-doctor',
        code: '1f468-200d-2695-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'female-doctor',
        code: '1f469-200d-2695-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'male-student',
        code: '1f468-200d-1f393',
        aliases: []
      },
      {
        skin: true,
        name: 'female-student',
        code: '1f469-200d-1f393',
        aliases: []
      },
      {
        skin: true,
        name: 'male-teacher',
        code: '1f468-200d-1f3eb',
        aliases: []
      },
      {
        skin: true,
        name: 'female-teacher',
        code: '1f469-200d-1f3eb',
        aliases: []
      },
      {
        skin: true,
        name: 'male-judge',
        code: '1f468-200d-2696-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'female-judge',
        code: '1f469-200d-2696-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'male-farmer',
        code: '1f468-200d-1f33e',
        aliases: []
      },
      {
        skin: true,
        name: 'female-farmer',
        code: '1f469-200d-1f33e',
        aliases: []
      },
      {
        skin: true,
        name: 'male-cook',
        code: '1f468-200d-1f373',
        aliases: []
      },
      {
        skin: true,
        name: 'female-cook',
        code: '1f469-200d-1f373',
        aliases: []
      },
      {
        skin: true,
        name: 'male-mechanic',
        code: '1f468-200d-1f527',
        aliases: []
      },
      {
        skin: true,
        name: 'female-mechanic',
        code: '1f469-200d-1f527',
        aliases: []
      },
      {
        skin: true,
        name: 'male-factory-worker',
        code: '1f468-200d-1f3ed',
        aliases: []
      },
      {
        skin: true,
        name: 'female-factory-worker',
        code: '1f469-200d-1f3ed',
        aliases: []
      },
      {
        skin: true,
        name: 'male-office-worker',
        code: '1f468-200d-1f4bc',
        aliases: []
      },
      {
        skin: true,
        name: 'female-office-worker',
        code: '1f469-200d-1f4bc',
        aliases: []
      },
      {
        skin: true,
        name: 'male-scientist',
        code: '1f468-200d-1f52c',
        aliases: []
      },
      {
        skin: true,
        name: 'female-scientist',
        code: '1f469-200d-1f52c',
        aliases: []
      },
      {
        skin: true,
        name: 'male-technologist',
        code: '1f468-200d-1f4bb',
        aliases: []
      },
      {
        skin: true,
        name: 'female-technologist',
        code: '1f469-200d-1f4bb',
        aliases: []
      },
      {
        skin: true,
        name: 'male-singer',
        code: '1f468-200d-1f3a4',
        aliases: []
      },
      {
        skin: true,
        name: 'female-singer',
        code: '1f469-200d-1f3a4',
        aliases: []
      },
      {
        skin: true,
        name: 'male-artist',
        code: '1f468-200d-1f3a8',
        aliases: []
      },
      {
        skin: true,
        name: 'female-artist',
        code: '1f469-200d-1f3a8',
        aliases: []
      },
      {
        skin: true,
        name: 'male-pilot',
        code: '1f468-200d-2708-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'female-pilot',
        code: '1f469-200d-2708-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'male-astronaut',
        code: '1f468-200d-1f680',
        aliases: []
      },
      {
        skin: true,
        name: 'female-astronaut',
        code: '1f469-200d-1f680',
        aliases: []
      },
      {
        skin: true,
        name: 'male-firefighter',
        code: '1f468-200d-1f692',
        aliases: []
      },
      {
        skin: true,
        name: 'female-firefighter',
        code: '1f469-200d-1f692',
        aliases: []
      },
      {
        skin: true,
        name: 'cop',
        code: '1f46e',
        aliases: []
      },
      {
        skin: true,
        name: 'male-police-officer',
        code: '1f46e-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'female-police-officer',
        code: '1f46e-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'sleuth_or_spy',
        code: '1f575-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'male-detective',
        code: '1f575-fe0f-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'female-detective',
        code: '1f575-fe0f-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'guardsman',
        code: '1f482',
        aliases: []
      },
      {
        skin: true,
        name: 'male-guard',
        code: '1f482-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'female-guard',
        code: '1f482-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'construction_worker',
        code: '1f477',
        aliases: []
      },
      {
        skin: true,
        name: 'male-construction-worker',
        code: '1f477-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'female-construction-worker',
        code: '1f477-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'prince',
        code: '1f934',
        aliases: []
      },
      {
        skin: true,
        name: 'princess',
        code: '1f478',
        aliases: []
      },
      {
        skin: true,
        name: 'man_with_turban',
        code: '1f473',
        aliases: []
      },
      {
        skin: true,
        name: 'man-wearing-turban',
        code: '1f473-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-wearing-turban',
        code: '1f473-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'man_with_gua_pi_mao',
        code: '1f472',
        aliases: []
      },
      {
        skin: true,
        name: 'person_with_headscarf',
        code: '1f9d5',
        aliases: []
      },
      {
        skin: true,
        name: 'bearded_person',
        code: '1f9d4',
        aliases: []
      },
      {
        skin: true,
        name: 'person_with_blond_hair',
        code: '1f471',
        aliases: []
      },
      {
        skin: true,
        name: 'blond-haired-man',
        code: '1f471-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'blond-haired-woman',
        code: '1f471-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'man_in_tuxedo',
        code: '1f935',
        aliases: []
      },
      {
        skin: true,
        name: 'bride_with_veil',
        code: '1f470',
        aliases: []
      },
      {
        skin: true,
        name: 'pregnant_woman',
        code: '1f930',
        aliases: []
      },
      {
        skin: true,
        name: 'breast-feeding',
        code: '1f931',
        aliases: []
      },
      {
        skin: true,
        name: 'angel',
        code: '1f47c',
        aliases: []
      },
      {
        skin: true,
        name: 'santa',
        code: '1f385',
        aliases: []
      },
      {
        skin: true,
        name: 'mrs_claus',
        code: '1f936',
        aliases: [
          'mother_christmas'
        ]
      },
      {
        skin: true,
        name: 'mage',
        code: '1f9d9',
        aliases: []
      },
      {
        skin: true,
        name: 'female_mage',
        code: '1f9d9-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'male_mage',
        code: '1f9d9-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'fairy',
        code: '1f9da',
        aliases: []
      },
      {
        skin: true,
        name: 'female_fairy',
        code: '1f9da-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'male_fairy',
        code: '1f9da-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'vampire',
        code: '1f9db',
        aliases: []
      },
      {
        skin: true,
        name: 'female_vampire',
        code: '1f9db-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'male_vampire',
        code: '1f9db-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'merperson',
        code: '1f9dc',
        aliases: []
      },
      {
        skin: true,
        name: 'mermaid',
        code: '1f9dc-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'merman',
        code: '1f9dc-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'elf',
        code: '1f9dd',
        aliases: []
      },
      {
        skin: true,
        name: 'female_elf',
        code: '1f9dd-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'male_elf',
        code: '1f9dd-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'genie',
        code: '1f9de',
        aliases: []
      },
      {
        skin: false,
        name: 'female_genie',
        code: '1f9de-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'male_genie',
        code: '1f9de-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'zombie',
        code: '1f9df',
        aliases: []
      },
      {
        skin: false,
        name: 'female_zombie',
        code: '1f9df-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'male_zombie',
        code: '1f9df-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'person_frowning',
        code: '1f64d',
        aliases: []
      },
      {
        skin: true,
        name: 'man-frowning',
        code: '1f64d-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-frowning',
        code: '1f64d-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'person_with_pouting_face',
        code: '1f64e',
        aliases: []
      },
      {
        skin: true,
        name: 'man-pouting',
        code: '1f64e-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-pouting',
        code: '1f64e-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'no_good',
        code: '1f645',
        aliases: []
      },
      {
        skin: true,
        name: 'man-gesturing-no',
        code: '1f645-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-gesturing-no',
        code: '1f645-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'ok_woman',
        code: '1f646',
        aliases: []
      },
      {
        skin: true,
        name: 'man-gesturing-ok',
        code: '1f646-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-gesturing-ok',
        code: '1f646-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'information_desk_person',
        code: '1f481',
        aliases: []
      },
      {
        skin: true,
        name: 'man-tipping-hand',
        code: '1f481-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-tipping-hand',
        code: '1f481-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'raising_hand',
        code: '1f64b',
        aliases: []
      },
      {
        skin: true,
        name: 'man-raising-hand',
        code: '1f64b-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-raising-hand',
        code: '1f64b-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'bow',
        code: '1f647',
        aliases: []
      },
      {
        skin: true,
        name: 'man-bowing',
        code: '1f647-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-bowing',
        code: '1f647-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'face_palm',
        code: '1f926',
        aliases: []
      },
      {
        skin: true,
        name: 'man-facepalming',
        code: '1f926-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-facepalming',
        code: '1f926-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'shrug',
        code: '1f937',
        aliases: []
      },
      {
        skin: true,
        name: 'man-shrugging',
        code: '1f937-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-shrugging',
        code: '1f937-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'massage',
        code: '1f486',
        aliases: []
      },
      {
        skin: true,
        name: 'man-getting-massage',
        code: '1f486-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-getting-massage',
        code: '1f486-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'haircut',
        code: '1f487',
        aliases: []
      },
      {
        skin: true,
        name: 'man-getting-haircut',
        code: '1f487-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-getting-haircut',
        code: '1f487-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'walking',
        code: '1f6b6',
        aliases: []
      },
      {
        skin: true,
        name: 'man-walking',
        code: '1f6b6-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-walking',
        code: '1f6b6-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'runner',
        code: '1f3c3',
        aliases: [
          'running'
        ]
      },
      {
        skin: true,
        name: 'man-running',
        code: '1f3c3-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-running',
        code: '1f3c3-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'dancer',
        code: '1f483',
        aliases: []
      },
      {
        skin: true,
        name: 'man_dancing',
        code: '1f57a',
        aliases: []
      },
      {
        skin: false,
        name: 'dancers',
        code: '1f46f',
        aliases: []
      },
      {
        skin: false,
        name: 'man-with-bunny-ears-partying',
        code: '1f46f-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'woman-with-bunny-ears-partying',
        code: '1f46f-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'person_in_steamy_room',
        code: '1f9d6',
        aliases: []
      },
      {
        skin: true,
        name: 'woman_in_steamy_room',
        code: '1f9d6-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'man_in_steamy_room',
        code: '1f9d6-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'person_climbing',
        code: '1f9d7',
        aliases: []
      },
      {
        skin: true,
        name: 'woman_climbing',
        code: '1f9d7-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'man_climbing',
        code: '1f9d7-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'person_in_lotus_position',
        code: '1f9d8',
        aliases: []
      },
      {
        skin: true,
        name: 'woman_in_lotus_position',
        code: '1f9d8-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'man_in_lotus_position',
        code: '1f9d8-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'bath',
        code: '1f6c0',
        aliases: []
      },
      {
        skin: true,
        name: 'sleeping_accommodation',
        code: '1f6cc',
        aliases: []
      },
      {
        skin: true,
        name: 'man_in_business_suit_levitating',
        code: '1f574-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'speaking_head_in_silhouette',
        code: '1f5e3-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'bust_in_silhouette',
        code: '1f464',
        aliases: []
      },
      {
        skin: false,
        name: 'busts_in_silhouette',
        code: '1f465',
        aliases: []
      },
      {
        skin: false,
        name: 'fencer',
        code: '1f93a',
        aliases: []
      },
      {
        skin: true,
        name: 'horse_racing',
        code: '1f3c7',
        aliases: []
      },
      {
        skin: false,
        name: 'skier',
        code: '26f7-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'snowboarder',
        code: '1f3c2',
        aliases: []
      },
      {
        skin: true,
        name: 'golfer',
        code: '1f3cc-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'man-golfing',
        code: '1f3cc-fe0f-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-golfing',
        code: '1f3cc-fe0f-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'surfer',
        code: '1f3c4',
        aliases: []
      },
      {
        skin: true,
        name: 'man-surfing',
        code: '1f3c4-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-surfing',
        code: '1f3c4-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'rowboat',
        code: '1f6a3',
        aliases: []
      },
      {
        skin: true,
        name: 'man-rowing-boat',
        code: '1f6a3-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-rowing-boat',
        code: '1f6a3-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'swimmer',
        code: '1f3ca',
        aliases: []
      },
      {
        skin: true,
        name: 'man-swimming',
        code: '1f3ca-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-swimming',
        code: '1f3ca-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'person_with_ball',
        code: '26f9-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'man-bouncing-ball',
        code: '26f9-fe0f-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-bouncing-ball',
        code: '26f9-fe0f-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'weight_lifter',
        code: '1f3cb-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'man-lifting-weights',
        code: '1f3cb-fe0f-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-lifting-weights',
        code: '1f3cb-fe0f-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'bicyclist',
        code: '1f6b4',
        aliases: []
      },
      {
        skin: true,
        name: 'man-biking',
        code: '1f6b4-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-biking',
        code: '1f6b4-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'mountain_bicyclist',
        code: '1f6b5',
        aliases: []
      },
      {
        skin: true,
        name: 'man-mountain-biking',
        code: '1f6b5-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-mountain-biking',
        code: '1f6b5-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'racing_car',
        code: '1f3ce-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'racing_motorcycle',
        code: '1f3cd-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'person_doing_cartwheel',
        code: '1f938',
        aliases: []
      },
      {
        skin: true,
        name: 'man-cartwheeling',
        code: '1f938-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-cartwheeling',
        code: '1f938-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'wrestlers',
        code: '1f93c',
        aliases: []
      },
      {
        skin: false,
        name: 'man-wrestling',
        code: '1f93c-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'woman-wrestling',
        code: '1f93c-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'water_polo',
        code: '1f93d',
        aliases: []
      },
      {
        skin: true,
        name: 'man-playing-water-polo',
        code: '1f93d-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-playing-water-polo',
        code: '1f93d-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'handball',
        code: '1f93e',
        aliases: []
      },
      {
        skin: true,
        name: 'man-playing-handball',
        code: '1f93e-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-playing-handball',
        code: '1f93e-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'juggling',
        code: '1f939',
        aliases: []
      },
      {
        skin: true,
        name: 'man-juggling',
        code: '1f939-200d-2642-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'woman-juggling',
        code: '1f939-200d-2640-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'couple',
        code: '1f46b',
        aliases: [
          'man_and_woman_holding_hands'
        ]
      },
      {
        skin: false,
        name: 'two_men_holding_hands',
        code: '1f46c',
        aliases: []
      },
      {
        skin: false,
        name: 'two_women_holding_hands',
        code: '1f46d',
        aliases: []
      },
      {
        skin: false,
        name: 'couplekiss',
        code: '1f48f',
        aliases: []
      },
      {
        skin: false,
        name: 'woman-kiss-man',
        code: '1f469-200d-2764-fe0f-200d-1f48b-200d-1f468',
        aliases: []
      },
      {
        skin: false,
        name: 'man-kiss-man',
        code: '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468',
        aliases: []
      },
      {
        skin: false,
        name: 'woman-kiss-woman',
        code: '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469',
        aliases: []
      },
      {
        skin: false,
        name: 'couple_with_heart',
        code: '1f491',
        aliases: []
      },
      {
        skin: false,
        name: 'woman-heart-man',
        code: '1f469-200d-2764-fe0f-200d-1f468',
        aliases: []
      },
      {
        skin: false,
        name: 'man-heart-man',
        code: '1f468-200d-2764-fe0f-200d-1f468',
        aliases: []
      },
      {
        skin: false,
        name: 'woman-heart-woman',
        code: '1f469-200d-2764-fe0f-200d-1f469',
        aliases: []
      },
      {
        skin: false,
        name: 'family',
        code: '1f46a',
        aliases: [
          'man-woman-boy'
        ]
      },
      {
        skin: false,
        name: 'man-woman-boy',
        code: '1f468-200d-1f469-200d-1f466',
        aliases: [
          'family'
        ]
      },
      {
        skin: false,
        name: 'man-woman-girl',
        code: '1f468-200d-1f469-200d-1f467',
        aliases: []
      },
      {
        skin: false,
        name: 'man-woman-girl-boy',
        code: '1f468-200d-1f469-200d-1f467-200d-1f466',
        aliases: []
      },
      {
        skin: false,
        name: 'man-woman-boy-boy',
        code: '1f468-200d-1f469-200d-1f466-200d-1f466',
        aliases: []
      },
      {
        skin: false,
        name: 'man-woman-girl-girl',
        code: '1f468-200d-1f469-200d-1f467-200d-1f467',
        aliases: []
      },
      {
        skin: false,
        name: 'man-man-boy',
        code: '1f468-200d-1f468-200d-1f466',
        aliases: []
      },
      {
        skin: false,
        name: 'man-man-girl',
        code: '1f468-200d-1f468-200d-1f467',
        aliases: []
      },
      {
        skin: false,
        name: 'man-man-girl-boy',
        code: '1f468-200d-1f468-200d-1f467-200d-1f466',
        aliases: []
      },
      {
        skin: false,
        name: 'man-man-boy-boy',
        code: '1f468-200d-1f468-200d-1f466-200d-1f466',
        aliases: []
      },
      {
        skin: false,
        name: 'man-man-girl-girl',
        code: '1f468-200d-1f468-200d-1f467-200d-1f467',
        aliases: []
      },
      {
        skin: false,
        name: 'woman-woman-boy',
        code: '1f469-200d-1f469-200d-1f466',
        aliases: []
      },
      {
        skin: false,
        name: 'woman-woman-girl',
        code: '1f469-200d-1f469-200d-1f467',
        aliases: []
      },
      {
        skin: false,
        name: 'woman-woman-girl-boy',
        code: '1f469-200d-1f469-200d-1f467-200d-1f466',
        aliases: []
      },
      {
        skin: false,
        name: 'woman-woman-boy-boy',
        code: '1f469-200d-1f469-200d-1f466-200d-1f466',
        aliases: []
      },
      {
        skin: false,
        name: 'woman-woman-girl-girl',
        code: '1f469-200d-1f469-200d-1f467-200d-1f467',
        aliases: []
      },
      {
        skin: false,
        name: 'man-boy',
        code: '1f468-200d-1f466',
        aliases: []
      },
      {
        skin: false,
        name: 'man-boy-boy',
        code: '1f468-200d-1f466-200d-1f466',
        aliases: []
      },
      {
        skin: false,
        name: 'man-girl',
        code: '1f468-200d-1f467',
        aliases: []
      },
      {
        skin: false,
        name: 'man-girl-boy',
        code: '1f468-200d-1f467-200d-1f466',
        aliases: []
      },
      {
        skin: false,
        name: 'man-girl-girl',
        code: '1f468-200d-1f467-200d-1f467',
        aliases: []
      },
      {
        skin: false,
        name: 'woman-boy',
        code: '1f469-200d-1f466',
        aliases: []
      },
      {
        skin: false,
        name: 'woman-boy-boy',
        code: '1f469-200d-1f466-200d-1f466',
        aliases: []
      },
      {
        skin: false,
        name: 'woman-girl',
        code: '1f469-200d-1f467',
        aliases: []
      },
      {
        skin: false,
        name: 'woman-girl-boy',
        code: '1f469-200d-1f467-200d-1f466',
        aliases: []
      },
      {
        skin: false,
        name: 'woman-girl-girl',
        code: '1f469-200d-1f467-200d-1f467',
        aliases: []
      },
      {
        skin: false,
        name: 'selfie',
        code: '1f933',
        aliases: []
      },
      {
        skin: true,
        name: 'muscle',
        code: '1f4aa',
        aliases: []
      },
      {
        skin: true,
        name: 'point_left',
        code: '1f448',
        aliases: []
      },
      {
        skin: true,
        name: 'point_right',
        code: '1f449',
        aliases: []
      },
      {
        skin: true,
        name: 'point_up',
        code: '261d-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'point_up_2',
        code: '1f446',
        aliases: []
      },
      {
        skin: true,
        name: 'middle_finger',
        code: '1f595',
        aliases: [
          'reversed_hand_with_middle_finger_extended'
        ]
      },
      {
        skin: true,
        name: 'point_down',
        code: '1f447',
        aliases: []
      },
      {
        skin: true,
        name: 'v',
        code: '270c-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'crossed_fingers',
        code: '1f91e',
        aliases: [
          'hand_with_index_and_middle_fingers_crossed'
        ]
      },
      {
        skin: true,
        name: 'spock-hand',
        code: '1f596',
        aliases: []
      },
      {
        skin: true,
        name: 'the_horns',
        code: '1f918',
        aliases: [
          'sign_of_the_horns'
        ]
      },
      {
        skin: true,
        name: 'call_me_hand',
        code: '1f919',
        aliases: []
      },
      {
        skin: true,
        name: 'raised_hand_with_fingers_splayed',
        code: '1f590-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'hand',
        code: '270b',
        aliases: [
          'raised_hand'
        ]
      },
      {
        skin: true,
        name: 'ok_hand',
        code: '1f44c',
        aliases: []
      },
      {
        skin: true,
        name: '+1',
        code: '1f44d',
        aliases: [
          'thumbsup'
        ]
      },
      {
        skin: true,
        name: '-1',
        code: '1f44e',
        aliases: [
          'thumbsdown'
        ]
      },
      {
        skin: true,
        name: 'fist',
        code: '270a',
        aliases: []
      },
      {
        skin: true,
        name: 'facepunch',
        code: '1f44a',
        aliases: [
          'punch'
        ]
      },
      {
        skin: true,
        name: 'left-facing_fist',
        code: '1f91b',
        aliases: []
      },
      {
        skin: true,
        name: 'right-facing_fist',
        code: '1f91c',
        aliases: []
      },
      {
        skin: true,
        name: 'raised_back_of_hand',
        code: '1f91a',
        aliases: []
      },
      {
        skin: true,
        name: 'wave',
        code: '1f44b',
        aliases: []
      },
      {
        skin: true,
        name: 'i_love_you_hand_sign',
        code: '1f91f',
        aliases: []
      },
      {
        skin: true,
        name: 'writing_hand',
        code: '270d-fe0f',
        aliases: []
      },
      {
        skin: true,
        name: 'clap',
        code: '1f44f',
        aliases: []
      },
      {
        skin: true,
        name: 'open_hands',
        code: '1f450',
        aliases: []
      },
      {
        skin: true,
        name: 'raised_hands',
        code: '1f64c',
        aliases: []
      },
      {
        skin: true,
        name: 'palms_up_together',
        code: '1f932',
        aliases: []
      },
      {
        skin: true,
        name: 'pray',
        code: '1f64f',
        aliases: []
      },
      {
        skin: false,
        name: 'handshake',
        code: '1f91d',
        aliases: []
      },
      {
        skin: true,
        name: 'nail_care',
        code: '1f485',
        aliases: []
      },
      {
        skin: true,
        name: 'ear',
        code: '1f442',
        aliases: []
      },
      {
        skin: true,
        name: 'nose',
        code: '1f443',
        aliases: []
      },
      {
        skin: false,
        name: 'footprints',
        code: '1f463',
        aliases: []
      },
      {
        skin: false,
        name: 'eyes',
        code: '1f440',
        aliases: []
      },
      {
        skin: false,
        name: 'eye',
        code: '1f441-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'eye-in-speech-bubble',
        code: '1f441-fe0f-200d-1f5e8-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'brain',
        code: '1f9e0',
        aliases: []
      },
      {
        skin: false,
        name: 'tongue',
        code: '1f445',
        aliases: []
      },
      {
        skin: false,
        name: 'lips',
        code: '1f444',
        aliases: []
      },
      {
        skin: false,
        name: 'kiss',
        code: '1f48b',
        aliases: []
      },
      {
        skin: false,
        name: 'cupid',
        code: '1f498',
        aliases: []
      },
      {
        skin: false,
        name: 'heart',
        code: '2764-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'heartbeat',
        code: '1f493',
        aliases: []
      },
      {
        skin: false,
        name: 'broken_heart',
        code: '1f494',
        aliases: []
      },
      {
        skin: false,
        name: 'two_hearts',
        code: '1f495',
        aliases: []
      },
      {
        skin: false,
        name: 'sparkling_heart',
        code: '1f496',
        aliases: []
      },
      {
        skin: false,
        name: 'heartpulse',
        code: '1f497',
        aliases: []
      },
      {
        skin: false,
        name: 'blue_heart',
        code: '1f499',
        aliases: []
      },
      {
        skin: false,
        name: 'green_heart',
        code: '1f49a',
        aliases: []
      },
      {
        skin: false,
        name: 'yellow_heart',
        code: '1f49b',
        aliases: []
      },
      {
        skin: false,
        name: 'orange_heart',
        code: '1f9e1',
        aliases: []
      },
      {
        skin: false,
        name: 'purple_heart',
        code: '1f49c',
        aliases: []
      },
      {
        skin: false,
        name: 'black_heart',
        code: '1f5a4',
        aliases: []
      },
      {
        skin: false,
        name: 'gift_heart',
        code: '1f49d',
        aliases: []
      },
      {
        skin: false,
        name: 'revolving_hearts',
        code: '1f49e',
        aliases: []
      },
      {
        skin: false,
        name: 'heart_decoration',
        code: '1f49f',
        aliases: []
      },
      {
        skin: false,
        name: 'heavy_heart_exclamation_mark_ornament',
        code: '2763-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'love_letter',
        code: '1f48c',
        aliases: []
      },
      {
        skin: false,
        name: 'zzz',
        code: '1f4a4',
        aliases: []
      },
      {
        skin: false,
        name: 'anger',
        code: '1f4a2',
        aliases: []
      },
      {
        skin: false,
        name: 'bomb',
        code: '1f4a3',
        aliases: []
      },
      {
        skin: false,
        name: 'boom',
        code: '1f4a5',
        aliases: [
          'collision'
        ]
      },
      {
        skin: false,
        name: 'sweat_drops',
        code: '1f4a6',
        aliases: []
      },
      {
        skin: false,
        name: 'dash',
        code: '1f4a8',
        aliases: []
      },
      {
        skin: false,
        name: 'dizzy',
        code: '1f4ab',
        aliases: []
      },
      {
        skin: false,
        name: 'speech_balloon',
        code: '1f4ac',
        aliases: []
      },
      {
        skin: false,
        name: 'left_speech_bubble',
        code: '1f5e8-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'right_anger_bubble',
        code: '1f5ef-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'thought_balloon',
        code: '1f4ad',
        aliases: []
      },
      {
        skin: false,
        name: 'hole',
        code: '1f573-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'eyeglasses',
        code: '1f453',
        aliases: []
      },
      {
        skin: false,
        name: 'dark_sunglasses',
        code: '1f576-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'necktie',
        code: '1f454',
        aliases: []
      },
      {
        skin: false,
        name: 'shirt',
        code: '1f455',
        aliases: [
          'tshirt'
        ]
      },
      {
        skin: false,
        name: 'jeans',
        code: '1f456',
        aliases: []
      },
      {
        skin: false,
        name: 'scarf',
        code: '1f9e3',
        aliases: []
      },
      {
        skin: false,
        name: 'gloves',
        code: '1f9e4',
        aliases: []
      },
      {
        skin: false,
        name: 'coat',
        code: '1f9e5',
        aliases: []
      },
      {
        skin: false,
        name: 'socks',
        code: '1f9e6',
        aliases: []
      },
      {
        skin: false,
        name: 'dress',
        code: '1f457',
        aliases: []
      },
      {
        skin: false,
        name: 'kimono',
        code: '1f458',
        aliases: []
      },
      {
        skin: false,
        name: 'bikini',
        code: '1f459',
        aliases: []
      },
      {
        skin: false,
        name: 'womans_clothes',
        code: '1f45a',
        aliases: []
      },
      {
        skin: false,
        name: 'purse',
        code: '1f45b',
        aliases: []
      },
      {
        skin: false,
        name: 'handbag',
        code: '1f45c',
        aliases: []
      },
      {
        skin: false,
        name: 'pouch',
        code: '1f45d',
        aliases: []
      },
      {
        skin: false,
        name: 'shopping_bags',
        code: '1f6cd-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'school_satchel',
        code: '1f392',
        aliases: []
      },
      {
        skin: false,
        name: 'mans_shoe',
        code: '1f45e',
        aliases: [
          'shoe'
        ]
      },
      {
        skin: false,
        name: 'athletic_shoe',
        code: '1f45f',
        aliases: []
      },
      {
        skin: false,
        name: 'high_heel',
        code: '1f460',
        aliases: []
      },
      {
        skin: false,
        name: 'sandal',
        code: '1f461',
        aliases: []
      },
      {
        skin: false,
        name: 'boot',
        code: '1f462',
        aliases: []
      },
      {
        skin: false,
        name: 'crown',
        code: '1f451',
        aliases: []
      },
      {
        skin: false,
        name: 'womans_hat',
        code: '1f452',
        aliases: []
      },
      {
        skin: false,
        name: 'tophat',
        code: '1f3a9',
        aliases: []
      },
      {
        skin: false,
        name: 'mortar_board',
        code: '1f393',
        aliases: []
      },
      {
        skin: false,
        name: 'billed_cap',
        code: '1f9e2',
        aliases: []
      },
      {
        skin: false,
        name: 'helmet_with_white_cross',
        code: '26d1-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'prayer_beads',
        code: '1f4ff',
        aliases: []
      },
      {
        skin: false,
        name: 'lipstick',
        code: '1f484',
        aliases: []
      },
      {
        skin: false,
        name: 'ring',
        code: '1f48d',
        aliases: []
      },
      {
        skin: false,
        name: 'gem',
        code: '1f48e',
        aliases: []
      },
    ]
  },
  {
    title: 't(Animals & Nature)',
    emojis: [
      {
        skin: false,
        name: 'monkey_face',
        code: '1f435',
        aliases: []
      },
      {
        skin: false,
        name: 'monkey',
        code: '1f412',
        aliases: []
      },
      {
        skin: false,
        name: 'gorilla',
        code: '1f98d',
        aliases: []
      },
      {
        skin: false,
        name: 'dog',
        code: '1f436',
        aliases: []
      },
      {
        skin: false,
        name: 'dog2',
        code: '1f415',
        aliases: []
      },
      {
        skin: false,
        name: 'poodle',
        code: '1f429',
        aliases: []
      },
      {
        skin: false,
        name: 'wolf',
        code: '1f43a',
        aliases: []
      },
      {
        skin: false,
        name: 'fox_face',
        code: '1f98a',
        aliases: []
      },
      {
        skin: false,
        name: 'cat',
        code: '1f431',
        aliases: []
      },
      {
        skin: false,
        name: 'cat2',
        code: '1f408',
        aliases: []
      },
      {
        skin: false,
        name: 'lion_face',
        code: '1f981',
        aliases: []
      },
      {
        skin: false,
        name: 'tiger',
        code: '1f42f',
        aliases: []
      },
      {
        skin: false,
        name: 'tiger2',
        code: '1f405',
        aliases: []
      },
      {
        skin: false,
        name: 'leopard',
        code: '1f406',
        aliases: []
      },
      {
        skin: false,
        name: 'horse',
        code: '1f434',
        aliases: []
      },
      {
        skin: false,
        name: 'racehorse',
        code: '1f40e',
        aliases: []
      },
      {
        skin: false,
        name: 'unicorn_face',
        code: '1f984',
        aliases: []
      },
      {
        skin: false,
        name: 'zebra_face',
        code: '1f993',
        aliases: []
      },
      {
        skin: false,
        name: 'deer',
        code: '1f98c',
        aliases: []
      },
      {
        skin: false,
        name: 'cow',
        code: '1f42e',
        aliases: []
      },
      {
        skin: false,
        name: 'ox',
        code: '1f402',
        aliases: []
      },
      {
        skin: false,
        name: 'water_buffalo',
        code: '1f403',
        aliases: []
      },
      {
        skin: false,
        name: 'cow2',
        code: '1f404',
        aliases: []
      },
      {
        skin: false,
        name: 'pig',
        code: '1f437',
        aliases: []
      },
      {
        skin: false,
        name: 'pig2',
        code: '1f416',
        aliases: []
      },
      {
        skin: false,
        name: 'boar',
        code: '1f417',
        aliases: []
      },
      {
        skin: false,
        name: 'pig_nose',
        code: '1f43d',
        aliases: []
      },
      {
        skin: false,
        name: 'ram',
        code: '1f40f',
        aliases: []
      },
      {
        skin: false,
        name: 'sheep',
        code: '1f411',
        aliases: []
      },
      {
        skin: false,
        name: 'goat',
        code: '1f410',
        aliases: []
      },
      {
        skin: false,
        name: 'dromedary_camel',
        code: '1f42a',
        aliases: []
      },
      {
        skin: false,
        name: 'camel',
        code: '1f42b',
        aliases: []
      },
      {
        skin: false,
        name: 'giraffe_face',
        code: '1f992',
        aliases: []
      },
      {
        skin: false,
        name: 'elephant',
        code: '1f418',
        aliases: []
      },
      {
        skin: false,
        name: 'rhinoceros',
        code: '1f98f',
        aliases: []
      },
      {
        skin: false,
        name: 'mouse',
        code: '1f42d',
        aliases: []
      },
      {
        skin: false,
        name: 'mouse2',
        code: '1f401',
        aliases: []
      },
      {
        skin: false,
        name: 'rat',
        code: '1f400',
        aliases: []
      },
      {
        skin: false,
        name: 'hamster',
        code: '1f439',
        aliases: []
      },
      {
        skin: false,
        name: 'rabbit',
        code: '1f430',
        aliases: []
      },
      {
        skin: false,
        name: 'rabbit2',
        code: '1f407',
        aliases: []
      },
      {
        skin: false,
        name: 'chipmunk',
        code: '1f43f-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'hedgehog',
        code: '1f994',
        aliases: []
      },
      {
        skin: false,
        name: 'bat',
        code: '1f987',
        aliases: []
      },
      {
        skin: false,
        name: 'bear',
        code: '1f43b',
        aliases: []
      },
      {
        skin: false,
        name: 'koala',
        code: '1f428',
        aliases: []
      },
      {
        skin: false,
        name: 'panda_face',
        code: '1f43c',
        aliases: []
      },
      {
        skin: false,
        name: 'feet',
        code: '1f43e',
        aliases: [
          'paw_prints'
        ]
      },
      {
        skin: false,
        name: 'turkey',
        code: '1f983',
        aliases: []
      },
      {
        skin: false,
        name: 'chicken',
        code: '1f414',
        aliases: []
      },
      {
        skin: false,
        name: 'rooster',
        code: '1f413',
        aliases: []
      },
      {
        skin: false,
        name: 'hatching_chick',
        code: '1f423',
        aliases: []
      },
      {
        skin: false,
        name: 'baby_chick',
        code: '1f424',
        aliases: []
      },
      {
        skin: false,
        name: 'hatched_chick',
        code: '1f425',
        aliases: []
      },
      {
        skin: false,
        name: 'bird',
        code: '1f426',
        aliases: []
      },
      {
        skin: false,
        name: 'penguin',
        code: '1f427',
        aliases: []
      },
      {
        skin: false,
        name: 'dove_of_peace',
        code: '1f54a-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'eagle',
        code: '1f985',
        aliases: []
      },
      {
        skin: false,
        name: 'duck',
        code: '1f986',
        aliases: []
      },
      {
        skin: false,
        name: 'owl',
        code: '1f989',
        aliases: []
      },
      {
        skin: false,
        name: 'frog',
        code: '1f438',
        aliases: []
      },
      {
        skin: false,
        name: 'crocodile',
        code: '1f40a',
        aliases: []
      },
      {
        skin: false,
        name: 'turtle',
        code: '1f422',
        aliases: []
      },
      {
        skin: false,
        name: 'lizard',
        code: '1f98e',
        aliases: []
      },
      {
        skin: false,
        name: 'snake',
        code: '1f40d',
        aliases: []
      },
      {
        skin: false,
        name: 'dragon_face',
        code: '1f432',
        aliases: []
      },
      {
        skin: false,
        name: 'dragon',
        code: '1f409',
        aliases: []
      },
      {
        skin: false,
        name: 'sauropod',
        code: '1f995',
        aliases: []
      },
      {
        skin: false,
        name: 't-rex',
        code: '1f996',
        aliases: []
      },
      {
        skin: false,
        name: 'whale',
        code: '1f433',
        aliases: []
      },
      {
        skin: false,
        name: 'whale2',
        code: '1f40b',
        aliases: []
      },
      {
        skin: false,
        name: 'dolphin',
        code: '1f42c',
        aliases: [
          'flipper'
        ]
      },
      {
        skin: false,
        name: 'fish',
        code: '1f41f',
        aliases: []
      },
      {
        skin: false,
        name: 'tropical_fish',
        code: '1f420',
        aliases: []
      },
      {
        skin: false,
        name: 'blowfish',
        code: '1f421',
        aliases: []
      },
      {
        skin: false,
        name: 'shark',
        code: '1f988',
        aliases: []
      },
      {
        skin: false,
        name: 'octopus',
        code: '1f419',
        aliases: []
      },
      {
        skin: false,
        name: 'shell',
        code: '1f41a',
        aliases: []
      },
      {
        skin: false,
        name: 'crab',
        code: '1f980',
        aliases: []
      },
      {
        skin: false,
        name: 'shrimp',
        code: '1f990',
        aliases: []
      },
      {
        skin: false,
        name: 'squid',
        code: '1f991',
        aliases: []
      },
      {
        skin: false,
        name: 'snail',
        code: '1f40c',
        aliases: []
      },
      {
        skin: false,
        name: 'butterfly',
        code: '1f98b',
        aliases: []
      },
      {
        skin: false,
        name: 'bug',
        code: '1f41b',
        aliases: []
      },
      {
        skin: false,
        name: 'ant',
        code: '1f41c',
        aliases: []
      },
      {
        skin: false,
        name: 'bee',
        code: '1f41d',
        aliases: [
          'honeybee'
        ]
      },
      {
        skin: false,
        name: 'beetle',
        code: '1f41e',
        aliases: []
      },
      {
        skin: false,
        name: 'cricket',
        code: '1f997',
        aliases: []
      },
      {
        skin: false,
        name: 'spider',
        code: '1f577-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'spider_web',
        code: '1f578-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'scorpion',
        code: '1f982',
        aliases: []
      },
      {
        skin: false,
        name: 'bouquet',
        code: '1f490',
        aliases: []
      },
      {
        skin: false,
        name: 'cherry_blossom',
        code: '1f338',
        aliases: []
      },
      {
        skin: false,
        name: 'white_flower',
        code: '1f4ae',
        aliases: []
      },
      {
        skin: false,
        name: 'rosette',
        code: '1f3f5-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'rose',
        code: '1f339',
        aliases: []
      },
      {
        skin: false,
        name: 'wilted_flower',
        code: '1f940',
        aliases: []
      },
      {
        skin: false,
        name: 'hibiscus',
        code: '1f33a',
        aliases: []
      },
      {
        skin: false,
        name: 'sunflower',
        code: '1f33b',
        aliases: []
      },
      {
        skin: false,
        name: 'blossom',
        code: '1f33c',
        aliases: []
      },
      {
        skin: false,
        name: 'tulip',
        code: '1f337',
        aliases: []
      },
      {
        skin: false,
        name: 'seedling',
        code: '1f331',
        aliases: []
      },
      {
        skin: false,
        name: 'evergreen_tree',
        code: '1f332',
        aliases: []
      },
      {
        skin: false,
        name: 'deciduous_tree',
        code: '1f333',
        aliases: []
      },
      {
        skin: false,
        name: 'palm_tree',
        code: '1f334',
        aliases: []
      },
      {
        skin: false,
        name: 'cactus',
        code: '1f335',
        aliases: []
      },
      {
        skin: false,
        name: 'ear_of_rice',
        code: '1f33e',
        aliases: []
      },
      {
        skin: false,
        name: 'herb',
        code: '1f33f',
        aliases: []
      },
      {
        skin: false,
        name: 'shamrock',
        code: '2618-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'four_leaf_clover',
        code: '1f340',
        aliases: []
      },
      {
        skin: false,
        name: 'maple_leaf',
        code: '1f341',
        aliases: []
      },
      {
        skin: false,
        name: 'fallen_leaf',
        code: '1f342',
        aliases: []
      },
      {
        skin: false,
        name: 'leaves',
        code: '1f343',
        aliases: []
      },
    ]
  },
  {
    title: 't(Food & Drink)',
    emojis: [
      {
        skin: false,
        name: 'grapes',
        code: '1f347',
        aliases: []
      },
      {
        skin: false,
        name: 'melon',
        code: '1f348',
        aliases: []
      },
      {
        skin: false,
        name: 'watermelon',
        code: '1f349',
        aliases: []
      },
      {
        skin: false,
        name: 'tangerine',
        code: '1f34a',
        aliases: []
      },
      {
        skin: false,
        name: 'lemon',
        code: '1f34b',
        aliases: []
      },
      {
        skin: false,
        name: 'banana',
        code: '1f34c',
        aliases: []
      },
      {
        skin: false,
        name: 'pineapple',
        code: '1f34d',
        aliases: []
      },
      {
        skin: false,
        name: 'apple',
        code: '1f34e',
        aliases: []
      },
      {
        skin: false,
        name: 'green_apple',
        code: '1f34f',
        aliases: []
      },
      {
        skin: false,
        name: 'pear',
        code: '1f350',
        aliases: []
      },
      {
        skin: false,
        name: 'peach',
        code: '1f351',
        aliases: []
      },
      {
        skin: false,
        name: 'cherries',
        code: '1f352',
        aliases: []
      },
      {
        skin: false,
        name: 'strawberry',
        code: '1f353',
        aliases: []
      },
      {
        skin: false,
        name: 'kiwifruit',
        code: '1f95d',
        aliases: []
      },
      {
        skin: false,
        name: 'tomato',
        code: '1f345',
        aliases: []
      },
      {
        skin: false,
        name: 'coconut',
        code: '1f965',
        aliases: []
      },
      {
        skin: false,
        name: 'avocado',
        code: '1f951',
        aliases: []
      },
      {
        skin: false,
        name: 'eggplant',
        code: '1f346',
        aliases: []
      },
      {
        skin: false,
        name: 'potato',
        code: '1f954',
        aliases: []
      },
      {
        skin: false,
        name: 'carrot',
        code: '1f955',
        aliases: []
      },
      {
        skin: false,
        name: 'corn',
        code: '1f33d',
        aliases: []
      },
      {
        skin: false,
        name: 'hot_pepper',
        code: '1f336-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'cucumber',
        code: '1f952',
        aliases: []
      },
      {
        skin: false,
        name: 'broccoli',
        code: '1f966',
        aliases: []
      },
      {
        skin: false,
        name: 'mushroom',
        code: '1f344',
        aliases: []
      },
      {
        skin: false,
        name: 'peanuts',
        code: '1f95c',
        aliases: []
      },
      {
        skin: false,
        name: 'chestnut',
        code: '1f330',
        aliases: []
      },
      {
        skin: false,
        name: 'bread',
        code: '1f35e',
        aliases: []
      },
      {
        skin: false,
        name: 'croissant',
        code: '1f950',
        aliases: []
      },
      {
        skin: false,
        name: 'baguette_bread',
        code: '1f956',
        aliases: []
      },
      {
        skin: false,
        name: 'pretzel',
        code: '1f968',
        aliases: []
      },
      {
        skin: false,
        name: 'pancakes',
        code: '1f95e',
        aliases: []
      },
      {
        skin: false,
        name: 'cheese_wedge',
        code: '1f9c0',
        aliases: []
      },
      {
        skin: false,
        name: 'meat_on_bone',
        code: '1f356',
        aliases: []
      },
      {
        skin: false,
        name: 'poultry_leg',
        code: '1f357',
        aliases: []
      },
      {
        skin: false,
        name: 'cut_of_meat',
        code: '1f969',
        aliases: []
      },
      {
        skin: false,
        name: 'bacon',
        code: '1f953',
        aliases: []
      },
      {
        skin: false,
        name: 'hamburger',
        code: '1f354',
        aliases: []
      },
      {
        skin: false,
        name: 'fries',
        code: '1f35f',
        aliases: []
      },
      {
        skin: false,
        name: 'pizza',
        code: '1f355',
        aliases: []
      },
      {
        skin: false,
        name: 'hotdog',
        code: '1f32d',
        aliases: []
      },
      {
        skin: false,
        name: 'sandwich',
        code: '1f96a',
        aliases: []
      },
      {
        skin: false,
        name: 'taco',
        code: '1f32e',
        aliases: []
      },
      {
        skin: false,
        name: 'burrito',
        code: '1f32f',
        aliases: []
      },
      {
        skin: false,
        name: 'stuffed_flatbread',
        code: '1f959',
        aliases: []
      },
      {
        skin: false,
        name: 'egg',
        code: '1f95a',
        aliases: []
      },
      {
        skin: false,
        name: 'fried_egg',
        code: '1f373',
        aliases: [
          'cooking'
        ]
      },
      {
        skin: false,
        name: 'shallow_pan_of_food',
        code: '1f958',
        aliases: []
      },
      {
        skin: false,
        name: 'stew',
        code: '1f372',
        aliases: []
      },
      {
        skin: false,
        name: 'bowl_with_spoon',
        code: '1f963',
        aliases: []
      },
      {
        skin: false,
        name: 'green_salad',
        code: '1f957',
        aliases: []
      },
      {
        skin: false,
        name: 'popcorn',
        code: '1f37f',
        aliases: []
      },
      {
        skin: false,
        name: 'canned_food',
        code: '1f96b',
        aliases: []
      },
      {
        skin: false,
        name: 'bento',
        code: '1f371',
        aliases: []
      },
      {
        skin: false,
        name: 'rice_cracker',
        code: '1f358',
        aliases: []
      },
      {
        skin: false,
        name: 'rice_ball',
        code: '1f359',
        aliases: []
      },
      {
        skin: false,
        name: 'rice',
        code: '1f35a',
        aliases: []
      },
      {
        skin: false,
        name: 'curry',
        code: '1f35b',
        aliases: []
      },
      {
        skin: false,
        name: 'ramen',
        code: '1f35c',
        aliases: []
      },
      {
        skin: false,
        name: 'spaghetti',
        code: '1f35d',
        aliases: []
      },
      {
        skin: false,
        name: 'sweet_potato',
        code: '1f360',
        aliases: []
      },
      {
        skin: false,
        name: 'oden',
        code: '1f362',
        aliases: []
      },
      {
        skin: false,
        name: 'sushi',
        code: '1f363',
        aliases: []
      },
      {
        skin: false,
        name: 'fried_shrimp',
        code: '1f364',
        aliases: []
      },
      {
        skin: false,
        name: 'fish_cake',
        code: '1f365',
        aliases: []
      },
      {
        skin: false,
        name: 'dango',
        code: '1f361',
        aliases: []
      },
      {
        skin: false,
        name: 'dumpling',
        code: '1f95f',
        aliases: []
      },
      {
        skin: false,
        name: 'fortune_cookie',
        code: '1f960',
        aliases: []
      },
      {
        skin: false,
        name: 'takeout_box',
        code: '1f961',
        aliases: []
      },
      {
        skin: false,
        name: 'icecream',
        code: '1f366',
        aliases: []
      },
      {
        skin: false,
        name: 'shaved_ice',
        code: '1f367',
        aliases: []
      },
      {
        skin: false,
        name: 'ice_cream',
        code: '1f368',
        aliases: []
      },
      {
        skin: false,
        name: 'doughnut',
        code: '1f369',
        aliases: []
      },
      {
        skin: false,
        name: 'cookie',
        code: '1f36a',
        aliases: []
      },
      {
        skin: false,
        name: 'birthday',
        code: '1f382',
        aliases: []
      },
      {
        skin: false,
        name: 'cake',
        code: '1f370',
        aliases: []
      },
      {
        skin: false,
        name: 'pie',
        code: '1f967',
        aliases: []
      },
      {
        skin: false,
        name: 'chocolate_bar',
        code: '1f36b',
        aliases: []
      },
      {
        skin: false,
        name: 'candy',
        code: '1f36c',
        aliases: []
      },
      {
        skin: false,
        name: 'lollipop',
        code: '1f36d',
        aliases: []
      },
      {
        skin: false,
        name: 'custard',
        code: '1f36e',
        aliases: []
      },
      {
        skin: false,
        name: 'honey_pot',
        code: '1f36f',
        aliases: []
      },
      {
        skin: false,
        name: 'baby_bottle',
        code: '1f37c',
        aliases: []
      },
      {
        skin: false,
        name: 'glass_of_milk',
        code: '1f95b',
        aliases: []
      },
      {
        skin: false,
        name: 'coffee',
        code: '2615',
        aliases: []
      },
      {
        skin: false,
        name: 'tea',
        code: '1f375',
        aliases: []
      },
      {
        skin: false,
        name: 'sake',
        code: '1f376',
        aliases: []
      },
      {
        skin: false,
        name: 'champagne',
        code: '1f37e',
        aliases: []
      },
      {
        skin: false,
        name: 'wine_glass',
        code: '1f377',
        aliases: []
      },
      {
        skin: false,
        name: 'cocktail',
        code: '1f378',
        aliases: []
      },
      {
        skin: false,
        name: 'tropical_drink',
        code: '1f379',
        aliases: []
      },
      {
        skin: false,
        name: 'beer',
        code: '1f37a',
        aliases: []
      },
      {
        skin: false,
        name: 'beers',
        code: '1f37b',
        aliases: []
      },
      {
        skin: false,
        name: 'clinking_glasses',
        code: '1f942',
        aliases: []
      },
      {
        skin: false,
        name: 'tumbler_glass',
        code: '1f943',
        aliases: []
      },
      {
        skin: false,
        name: 'cup_with_straw',
        code: '1f964',
        aliases: []
      },
      {
        skin: false,
        name: 'chopsticks',
        code: '1f962',
        aliases: []
      },
      {
        skin: false,
        name: 'knife_fork_plate',
        code: '1f37d-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'fork_and_knife',
        code: '1f374',
        aliases: []
      },
      {
        skin: false,
        name: 'spoon',
        code: '1f944',
        aliases: []
      },
      {
        skin: false,
        name: 'hocho',
        code: '1f52a',
        aliases: [
          'knife'
        ]
      },
      {
        skin: false,
        name: 'amphora',
        code: '1f3fa',
        aliases: []
      },
    ]
  },
  {
    title: 't(Travel & Places)',
    emojis: [
      {
        skin: false,
        name: 'earth_africa',
        code: '1f30d',
        aliases: []
      },
      {
        skin: false,
        name: 'earth_americas',
        code: '1f30e',
        aliases: []
      },
      {
        skin: false,
        name: 'earth_asia',
        code: '1f30f',
        aliases: []
      },
      {
        skin: false,
        name: 'globe_with_meridians',
        code: '1f310',
        aliases: []
      },
      {
        skin: false,
        name: 'world_map',
        code: '1f5fa-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'japan',
        code: '1f5fe',
        aliases: []
      },
      {
        skin: false,
        name: 'snow_capped_mountain',
        code: '1f3d4-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'mountain',
        code: '26f0-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'volcano',
        code: '1f30b',
        aliases: []
      },
      {
        skin: false,
        name: 'mount_fuji',
        code: '1f5fb',
        aliases: []
      },
      {
        skin: false,
        name: 'camping',
        code: '1f3d5-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'beach_with_umbrella',
        code: '1f3d6-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'desert',
        code: '1f3dc-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'desert_island',
        code: '1f3dd-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'national_park',
        code: '1f3de-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'stadium',
        code: '1f3df-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'classical_building',
        code: '1f3db-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'building_construction',
        code: '1f3d7-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'house_buildings',
        code: '1f3d8-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'cityscape',
        code: '1f3d9-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'derelict_house_building',
        code: '1f3da-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'house',
        code: '1f3e0',
        aliases: []
      },
      {
        skin: false,
        name: 'house_with_garden',
        code: '1f3e1',
        aliases: []
      },
      {
        skin: false,
        name: 'office',
        code: '1f3e2',
        aliases: []
      },
      {
        skin: false,
        name: 'post_office',
        code: '1f3e3',
        aliases: []
      },
      {
        skin: false,
        name: 'european_post_office',
        code: '1f3e4',
        aliases: []
      },
      {
        skin: false,
        name: 'hospital',
        code: '1f3e5',
        aliases: []
      },
      {
        skin: false,
        name: 'bank',
        code: '1f3e6',
        aliases: []
      },
      {
        skin: false,
        name: 'hotel',
        code: '1f3e8',
        aliases: []
      },
      {
        skin: false,
        name: 'love_hotel',
        code: '1f3e9',
        aliases: []
      },
      {
        skin: false,
        name: 'convenience_store',
        code: '1f3ea',
        aliases: []
      },
      {
        skin: false,
        name: 'school',
        code: '1f3eb',
        aliases: []
      },
      {
        skin: false,
        name: 'department_store',
        code: '1f3ec',
        aliases: []
      },
      {
        skin: false,
        name: 'factory',
        code: '1f3ed',
        aliases: []
      },
      {
        skin: false,
        name: 'japanese_castle',
        code: '1f3ef',
        aliases: []
      },
      {
        skin: false,
        name: 'european_castle',
        code: '1f3f0',
        aliases: []
      },
      {
        skin: false,
        name: 'wedding',
        code: '1f492',
        aliases: []
      },
      {
        skin: false,
        name: 'tokyo_tower',
        code: '1f5fc',
        aliases: []
      },
      {
        skin: false,
        name: 'statue_of_liberty',
        code: '1f5fd',
        aliases: []
      },
      {
        skin: false,
        name: 'church',
        code: '26ea',
        aliases: []
      },
      {
        skin: false,
        name: 'mosque',
        code: '1f54c',
        aliases: []
      },
      {
        skin: false,
        name: 'synagogue',
        code: '1f54d',
        aliases: []
      },
      {
        skin: false,
        name: 'shinto_shrine',
        code: '26e9-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'kaaba',
        code: '1f54b',
        aliases: []
      },
      {
        skin: false,
        name: 'fountain',
        code: '26f2',
        aliases: []
      },
      {
        skin: false,
        name: 'tent',
        code: '26fa',
        aliases: []
      },
      {
        skin: false,
        name: 'foggy',
        code: '1f301',
        aliases: []
      },
      {
        skin: false,
        name: 'night_with_stars',
        code: '1f303',
        aliases: []
      },
      {
        skin: false,
        name: 'sunrise_over_mountains',
        code: '1f304',
        aliases: []
      },
      {
        skin: false,
        name: 'sunrise',
        code: '1f305',
        aliases: []
      },
      {
        skin: false,
        name: 'city_sunset',
        code: '1f306',
        aliases: []
      },
      {
        skin: false,
        name: 'city_sunrise',
        code: '1f307',
        aliases: []
      },
      {
        skin: false,
        name: 'bridge_at_night',
        code: '1f309',
        aliases: []
      },
      {
        skin: false,
        name: 'hotsprings',
        code: '2668-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'milky_way',
        code: '1f30c',
        aliases: []
      },
      {
        skin: false,
        name: 'carousel_horse',
        code: '1f3a0',
        aliases: []
      },
      {
        skin: false,
        name: 'ferris_wheel',
        code: '1f3a1',
        aliases: []
      },
      {
        skin: false,
        name: 'roller_coaster',
        code: '1f3a2',
        aliases: []
      },
      {
        skin: false,
        name: 'barber',
        code: '1f488',
        aliases: []
      },
      {
        skin: false,
        name: 'circus_tent',
        code: '1f3aa',
        aliases: []
      },
      {
        skin: false,
        name: 'performing_arts',
        code: '1f3ad',
        aliases: []
      },
      {
        skin: false,
        name: 'frame_with_picture',
        code: '1f5bc-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'art',
        code: '1f3a8',
        aliases: []
      },
      {
        skin: false,
        name: 'slot_machine',
        code: '1f3b0',
        aliases: []
      },
      {
        skin: false,
        name: 'steam_locomotive',
        code: '1f682',
        aliases: []
      },
      {
        skin: false,
        name: 'railway_car',
        code: '1f683',
        aliases: []
      },
      {
        skin: false,
        name: 'bullettrain_side',
        code: '1f684',
        aliases: []
      },
      {
        skin: false,
        name: 'bullettrain_front',
        code: '1f685',
        aliases: []
      },
      {
        skin: false,
        name: 'train2',
        code: '1f686',
        aliases: []
      },
      {
        skin: false,
        name: 'metro',
        code: '1f687',
        aliases: []
      },
      {
        skin: false,
        name: 'light_rail',
        code: '1f688',
        aliases: []
      },
      {
        skin: false,
        name: 'station',
        code: '1f689',
        aliases: []
      },
      {
        skin: false,
        name: 'tram',
        code: '1f68a',
        aliases: []
      },
      {
        skin: false,
        name: 'monorail',
        code: '1f69d',
        aliases: []
      },
      {
        skin: false,
        name: 'mountain_railway',
        code: '1f69e',
        aliases: []
      },
      {
        skin: false,
        name: 'train',
        code: '1f68b',
        aliases: []
      },
      {
        skin: false,
        name: 'bus',
        code: '1f68c',
        aliases: []
      },
      {
        skin: false,
        name: 'oncoming_bus',
        code: '1f68d',
        aliases: []
      },
      {
        skin: false,
        name: 'trolleybus',
        code: '1f68e',
        aliases: []
      },
      {
        skin: false,
        name: 'minibus',
        code: '1f690',
        aliases: []
      },
      {
        skin: false,
        name: 'ambulance',
        code: '1f691',
        aliases: []
      },
      {
        skin: false,
        name: 'fire_engine',
        code: '1f692',
        aliases: []
      },
      {
        skin: false,
        name: 'police_car',
        code: '1f693',
        aliases: []
      },
      {
        skin: false,
        name: 'oncoming_police_car',
        code: '1f694',
        aliases: []
      },
      {
        skin: false,
        name: 'taxi',
        code: '1f695',
        aliases: []
      },
      {
        skin: false,
        name: 'oncoming_taxi',
        code: '1f696',
        aliases: []
      },
      {
        skin: false,
        name: 'car',
        code: '1f697',
        aliases: [
          'red_car'
        ]
      },
      {
        skin: false,
        name: 'oncoming_automobile',
        code: '1f698',
        aliases: []
      },
      {
        skin: false,
        name: 'blue_car',
        code: '1f699',
        aliases: []
      },
      {
        skin: false,
        name: 'truck',
        code: '1f69a',
        aliases: []
      },
      {
        skin: false,
        name: 'articulated_lorry',
        code: '1f69b',
        aliases: []
      },
      {
        skin: false,
        name: 'tractor',
        code: '1f69c',
        aliases: []
      },
      {
        skin: false,
        name: 'bike',
        code: '1f6b2',
        aliases: []
      },
      {
        skin: false,
        name: 'scooter',
        code: '1f6f4',
        aliases: []
      },
      {
        skin: false,
        name: 'motor_scooter',
        code: '1f6f5',
        aliases: []
      },
      {
        skin: false,
        name: 'busstop',
        code: '1f68f',
        aliases: []
      },
      {
        skin: false,
        name: 'motorway',
        code: '1f6e3-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'railway_track',
        code: '1f6e4-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'fuelpump',
        code: '26fd',
        aliases: []
      },
      {
        skin: false,
        name: 'rotating_light',
        code: '1f6a8',
        aliases: []
      },
      {
        skin: false,
        name: 'traffic_light',
        code: '1f6a5',
        aliases: []
      },
      {
        skin: false,
        name: 'vertical_traffic_light',
        code: '1f6a6',
        aliases: []
      },
      {
        skin: false,
        name: 'construction',
        code: '1f6a7',
        aliases: []
      },
      {
        skin: false,
        name: 'octagonal_sign',
        code: '1f6d1',
        aliases: []
      },
      {
        skin: false,
        name: 'anchor',
        code: '2693',
        aliases: []
      },
      {
        skin: false,
        name: 'boat',
        code: '26f5',
        aliases: [
          'sailboat'
        ]
      },
      {
        skin: false,
        name: 'canoe',
        code: '1f6f6',
        aliases: []
      },
      {
        skin: false,
        name: 'speedboat',
        code: '1f6a4',
        aliases: []
      },
      {
        skin: false,
        name: 'passenger_ship',
        code: '1f6f3-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'ferry',
        code: '26f4-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'motor_boat',
        code: '1f6e5-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'ship',
        code: '1f6a2',
        aliases: []
      },
      {
        skin: false,
        name: 'airplane',
        code: '2708-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'small_airplane',
        code: '1f6e9-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'airplane_departure',
        code: '1f6eb',
        aliases: []
      },
      {
        skin: false,
        name: 'airplane_arriving',
        code: '1f6ec',
        aliases: []
      },
      {
        skin: false,
        name: 'seat',
        code: '1f4ba',
        aliases: []
      },
      {
        skin: false,
        name: 'helicopter',
        code: '1f681',
        aliases: []
      },
      {
        skin: false,
        name: 'suspension_railway',
        code: '1f69f',
        aliases: []
      },
      {
        skin: false,
        name: 'mountain_cableway',
        code: '1f6a0',
        aliases: []
      },
      {
        skin: false,
        name: 'aerial_tramway',
        code: '1f6a1',
        aliases: []
      },
      {
        skin: false,
        name: 'satellite',
        code: '1f6f0-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'rocket',
        code: '1f680',
        aliases: []
      },
      {
        skin: false,
        name: 'flying_saucer',
        code: '1f6f8',
        aliases: []
      },
      {
        skin: false,
        name: 'bellhop_bell',
        code: '1f6ce-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'door',
        code: '1f6aa',
        aliases: []
      },
      {
        skin: false,
        name: 'bed',
        code: '1f6cf-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'couch_and_lamp',
        code: '1f6cb-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'toilet',
        code: '1f6bd',
        aliases: []
      },
      {
        skin: false,
        name: 'shower',
        code: '1f6bf',
        aliases: []
      },
      {
        skin: false,
        name: 'bathtub',
        code: '1f6c1',
        aliases: []
      },
      {
        skin: false,
        name: 'hourglass',
        code: '231b',
        aliases: []
      },
      {
        skin: false,
        name: 'hourglass_flowing_sand',
        code: '23f3',
        aliases: []
      },
      {
        skin: false,
        name: 'watch',
        code: '231a',
        aliases: []
      },
      {
        skin: false,
        name: 'alarm_clock',
        code: '23f0',
        aliases: []
      },
      {
        skin: false,
        name: 'stopwatch',
        code: '23f1-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'timer_clock',
        code: '23f2-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'mantelpiece_clock',
        code: '1f570-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'clock12',
        code: '1f55b',
        aliases: []
      },
      {
        skin: false,
        name: 'clock1230',
        code: '1f567',
        aliases: []
      },
      {
        skin: false,
        name: 'clock1',
        code: '1f550',
        aliases: []
      },
      {
        skin: false,
        name: 'clock130',
        code: '1f55c',
        aliases: []
      },
      {
        skin: false,
        name: 'clock2',
        code: '1f551',
        aliases: []
      },
      {
        skin: false,
        name: 'clock230',
        code: '1f55d',
        aliases: []
      },
      {
        skin: false,
        name: 'clock3',
        code: '1f552',
        aliases: []
      },
      {
        skin: false,
        name: 'clock330',
        code: '1f55e',
        aliases: []
      },
      {
        skin: false,
        name: 'clock4',
        code: '1f553',
        aliases: []
      },
      {
        skin: false,
        name: 'clock430',
        code: '1f55f',
        aliases: []
      },
      {
        skin: false,
        name: 'clock5',
        code: '1f554',
        aliases: []
      },
      {
        skin: false,
        name: 'clock530',
        code: '1f560',
        aliases: []
      },
      {
        skin: false,
        name: 'clock6',
        code: '1f555',
        aliases: []
      },
      {
        skin: false,
        name: 'clock630',
        code: '1f561',
        aliases: []
      },
      {
        skin: false,
        name: 'clock7',
        code: '1f556',
        aliases: []
      },
      {
        skin: false,
        name: 'clock730',
        code: '1f562',
        aliases: []
      },
      {
        skin: false,
        name: 'clock8',
        code: '1f557',
        aliases: []
      },
      {
        skin: false,
        name: 'clock830',
        code: '1f563',
        aliases: []
      },
      {
        skin: false,
        name: 'clock9',
        code: '1f558',
        aliases: []
      },
      {
        skin: false,
        name: 'clock930',
        code: '1f564',
        aliases: []
      },
      {
        skin: false,
        name: 'clock10',
        code: '1f559',
        aliases: []
      },
      {
        skin: false,
        name: 'clock1030',
        code: '1f565',
        aliases: []
      },
      {
        skin: false,
        name: 'clock11',
        code: '1f55a',
        aliases: []
      },
      {
        skin: false,
        name: 'clock1130',
        code: '1f566',
        aliases: []
      },
      {
        skin: false,
        name: 'new_moon',
        code: '1f311',
        aliases: []
      },
      {
        skin: false,
        name: 'waxing_crescent_moon',
        code: '1f312',
        aliases: []
      },
      {
        skin: false,
        name: 'first_quarter_moon',
        code: '1f313',
        aliases: []
      },
      {
        skin: false,
        name: 'moon',
        code: '1f314',
        aliases: [
          'waxing_gibbous_moon'
        ]
      },
      {
        skin: false,
        name: 'full_moon',
        code: '1f315',
        aliases: []
      },
      {
        skin: false,
        name: 'waning_gibbous_moon',
        code: '1f316',
        aliases: []
      },
      {
        skin: false,
        name: 'last_quarter_moon',
        code: '1f317',
        aliases: []
      },
      {
        skin: false,
        name: 'waning_crescent_moon',
        code: '1f318',
        aliases: []
      },
      {
        skin: false,
        name: 'crescent_moon',
        code: '1f319',
        aliases: []
      },
      {
        skin: false,
        name: 'new_moon_with_face',
        code: '1f31a',
        aliases: []
      },
      {
        skin: false,
        name: 'first_quarter_moon_with_face',
        code: '1f31b',
        aliases: []
      },
      {
        skin: false,
        name: 'last_quarter_moon_with_face',
        code: '1f31c',
        aliases: []
      },
      {
        skin: false,
        name: 'thermometer',
        code: '1f321-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'sunny',
        code: '2600-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'full_moon_with_face',
        code: '1f31d',
        aliases: []
      },
      {
        skin: false,
        name: 'sun_with_face',
        code: '1f31e',
        aliases: []
      },
      {
        skin: false,
        name: 'star',
        code: '2b50',
        aliases: []
      },
      {
        skin: false,
        name: 'star2',
        code: '1f31f',
        aliases: []
      },
      {
        skin: false,
        name: 'stars',
        code: '1f320',
        aliases: []
      },
      {
        skin: false,
        name: 'cloud',
        code: '2601-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'partly_sunny',
        code: '26c5',
        aliases: []
      },
      {
        skin: false,
        name: 'thunder_cloud_and_rain',
        code: '26c8-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'mostly_sunny',
        code: '1f324-fe0f',
        aliases: [
          'sun_small_cloud'
        ]
      },
      {
        skin: false,
        name: 'barely_sunny',
        code: '1f325-fe0f',
        aliases: [
          'sun_behind_cloud'
        ]
      },
      {
        skin: false,
        name: 'partly_sunny_rain',
        code: '1f326-fe0f',
        aliases: [
          'sun_behind_rain_cloud'
        ]
      },
      {
        skin: false,
        name: 'rain_cloud',
        code: '1f327-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'snow_cloud',
        code: '1f328-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'lightning',
        code: '1f329-fe0f',
        aliases: [
          'lightning_cloud'
        ]
      },
      {
        skin: false,
        name: 'tornado',
        code: '1f32a-fe0f',
        aliases: [
          'tornado_cloud'
        ]
      },
      {
        skin: false,
        name: 'fog',
        code: '1f32b-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'wind_blowing_face',
        code: '1f32c-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'cyclone',
        code: '1f300',
        aliases: []
      },
      {
        skin: false,
        name: 'rainbow',
        code: '1f308',
        aliases: []
      },
      {
        skin: false,
        name: 'closed_umbrella',
        code: '1f302',
        aliases: []
      },
      {
        skin: false,
        name: 'umbrella',
        code: '2602-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'umbrella_with_rain_drops',
        code: '2614',
        aliases: []
      },
      {
        skin: false,
        name: 'umbrella_on_ground',
        code: '26f1-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'zap',
        code: '26a1',
        aliases: []
      },
      {
        skin: false,
        name: 'snowflake',
        code: '2744-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'snowman',
        code: '2603-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'snowman_without_snow',
        code: '26c4',
        aliases: []
      },
      {
        skin: false,
        name: 'comet',
        code: '2604-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'fire',
        code: '1f525',
        aliases: []
      },
      {
        skin: false,
        name: 'droplet',
        code: '1f4a7',
        aliases: []
      },
      {
        skin: false,
        name: 'ocean',
        code: '1f30a',
        aliases: []
      },
    ]
  },
  {
    title: 't(Activities)',
    emojis: [
      {
        skin: false,
        name: 'jack_o_lantern',
        code: '1f383',
        aliases: []
      },
      {
        skin: false,
        name: 'christmas_tree',
        code: '1f384',
        aliases: []
      },
      {
        skin: false,
        name: 'fireworks',
        code: '1f386',
        aliases: []
      },
      {
        skin: false,
        name: 'sparkler',
        code: '1f387',
        aliases: []
      },
      {
        skin: false,
        name: 'sparkles',
        code: '2728',
        aliases: []
      },
      {
        skin: false,
        name: 'balloon',
        code: '1f388',
        aliases: []
      },
      {
        skin: false,
        name: 'tada',
        code: '1f389',
        aliases: []
      },
      {
        skin: false,
        name: 'confetti_ball',
        code: '1f38a',
        aliases: []
      },
      {
        skin: false,
        name: 'tanabata_tree',
        code: '1f38b',
        aliases: []
      },
      {
        skin: false,
        name: 'bamboo',
        code: '1f38d',
        aliases: []
      },
      {
        skin: false,
        name: 'dolls',
        code: '1f38e',
        aliases: []
      },
      {
        skin: false,
        name: 'flags',
        code: '1f38f',
        aliases: []
      },
      {
        skin: false,
        name: 'wind_chime',
        code: '1f390',
        aliases: []
      },
      {
        skin: false,
        name: 'rice_scene',
        code: '1f391',
        aliases: []
      },
      {
        skin: false,
        name: 'ribbon',
        code: '1f380',
        aliases: []
      },
      {
        skin: false,
        name: 'gift',
        code: '1f381',
        aliases: []
      },
      {
        skin: false,
        name: 'reminder_ribbon',
        code: '1f397-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'admission_tickets',
        code: '1f39f-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'ticket',
        code: '1f3ab',
        aliases: []
      },
      {
        skin: false,
        name: 'medal',
        code: '1f396-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'trophy',
        code: '1f3c6',
        aliases: []
      },
      {
        skin: false,
        name: 'sports_medal',
        code: '1f3c5',
        aliases: []
      },
      {
        skin: false,
        name: 'first_place_medal',
        code: '1f947',
        aliases: []
      },
      {
        skin: false,
        name: 'second_place_medal',
        code: '1f948',
        aliases: []
      },
      {
        skin: false,
        name: 'third_place_medal',
        code: '1f949',
        aliases: []
      },
      {
        skin: false,
        name: 'soccer',
        code: '26bd',
        aliases: []
      },
      {
        skin: false,
        name: 'baseball',
        code: '26be',
        aliases: []
      },
      {
        skin: false,
        name: 'basketball',
        code: '1f3c0',
        aliases: []
      },
      {
        skin: false,
        name: 'volleyball',
        code: '1f3d0',
        aliases: []
      },
      {
        skin: false,
        name: 'football',
        code: '1f3c8',
        aliases: []
      },
      {
        skin: false,
        name: 'rugby_football',
        code: '1f3c9',
        aliases: []
      },
      {
        skin: false,
        name: 'tennis',
        code: '1f3be',
        aliases: []
      },
      {
        skin: false,
        name: '8ball',
        code: '1f3b1',
        aliases: []
      },
      {
        skin: false,
        name: 'bowling',
        code: '1f3b3',
        aliases: []
      },
      {
        skin: false,
        name: 'cricket_bat_and_ball',
        code: '1f3cf',
        aliases: []
      },
      {
        skin: false,
        name: 'field_hockey_stick_and_ball',
        code: '1f3d1',
        aliases: []
      },
      {
        skin: false,
        name: 'ice_hockey_stick_and_puck',
        code: '1f3d2',
        aliases: []
      },
      {
        skin: false,
        name: 'table_tennis_paddle_and_ball',
        code: '1f3d3',
        aliases: []
      },
      {
        skin: false,
        name: 'badminton_racquet_and_shuttlecock',
        code: '1f3f8',
        aliases: []
      },
      {
        skin: false,
        name: 'boxing_glove',
        code: '1f94a',
        aliases: []
      },
      {
        skin: false,
        name: 'martial_arts_uniform',
        code: '1f94b',
        aliases: []
      },
      {
        skin: false,
        name: 'goal_net',
        code: '1f945',
        aliases: []
      },
      {
        skin: false,
        name: 'dart',
        code: '1f3af',
        aliases: []
      },
      {
        skin: false,
        name: 'golf',
        code: '26f3',
        aliases: []
      },
      {
        skin: false,
        name: 'ice_skate',
        code: '26f8-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'fishing_pole_and_fish',
        code: '1f3a3',
        aliases: []
      },
      {
        skin: false,
        name: 'running_shirt_with_sash',
        code: '1f3bd',
        aliases: []
      },
      {
        skin: false,
        name: 'ski',
        code: '1f3bf',
        aliases: []
      },
      {
        skin: false,
        name: 'sled',
        code: '1f6f7',
        aliases: []
      },
      {
        skin: false,
        name: 'curling_stone',
        code: '1f94c',
        aliases: []
      },
      {
        skin: false,
        name: 'video_game',
        code: '1f3ae',
        aliases: []
      },
      {
        skin: false,
        name: 'joystick',
        code: '1f579-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'game_die',
        code: '1f3b2',
        aliases: []
      },
      {
        skin: false,
        name: 'spades',
        code: '2660-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'hearts',
        code: '2665-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'diamonds',
        code: '2666-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'clubs',
        code: '2663-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'black_joker',
        code: '1f0cf',
        aliases: []
      },
      {
        skin: false,
        name: 'mahjong',
        code: '1f004',
        aliases: []
      },
      {
        skin: false,
        name: 'flower_playing_cards',
        code: '1f3b4',
        aliases: []
      },
    ]
  },
  {
    title: 't(Objects)',
    emojis: [
      {
        skin: false,
        name: 'mute',
        code: '1f507',
        aliases: []
      },
      {
        skin: false,
        name: 'speaker',
        code: '1f508',
        aliases: []
      },
      {
        skin: false,
        name: 'sound',
        code: '1f509',
        aliases: []
      },
      {
        skin: false,
        name: 'loud_sound',
        code: '1f50a',
        aliases: []
      },
      {
        skin: false,
        name: 'loudspeaker',
        code: '1f4e2',
        aliases: []
      },
      {
        skin: false,
        name: 'mega',
        code: '1f4e3',
        aliases: []
      },
      {
        skin: false,
        name: 'postal_horn',
        code: '1f4ef',
        aliases: []
      },
      {
        skin: false,
        name: 'bell',
        code: '1f514',
        aliases: []
      },
      {
        skin: false,
        name: 'no_bell',
        code: '1f515',
        aliases: []
      },
      {
        skin: false,
        name: 'musical_score',
        code: '1f3bc',
        aliases: []
      },
      {
        skin: false,
        name: 'musical_note',
        code: '1f3b5',
        aliases: []
      },
      {
        skin: false,
        name: 'notes',
        code: '1f3b6',
        aliases: []
      },
      {
        skin: false,
        name: 'studio_microphone',
        code: '1f399-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'level_slider',
        code: '1f39a-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'control_knobs',
        code: '1f39b-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'microphone',
        code: '1f3a4',
        aliases: []
      },
      {
        skin: false,
        name: 'headphones',
        code: '1f3a7',
        aliases: []
      },
      {
        skin: false,
        name: 'radio',
        code: '1f4fb',
        aliases: []
      },
      {
        skin: false,
        name: 'saxophone',
        code: '1f3b7',
        aliases: []
      },
      {
        skin: false,
        name: 'guitar',
        code: '1f3b8',
        aliases: []
      },
      {
        skin: false,
        name: 'musical_keyboard',
        code: '1f3b9',
        aliases: []
      },
      {
        skin: false,
        name: 'trumpet',
        code: '1f3ba',
        aliases: []
      },
      {
        skin: false,
        name: 'violin',
        code: '1f3bb',
        aliases: []
      },
      {
        skin: false,
        name: 'drum_with_drumsticks',
        code: '1f941',
        aliases: []
      },
      {
        skin: false,
        name: 'iphone',
        code: '1f4f1',
        aliases: []
      },
      {
        skin: false,
        name: 'calling',
        code: '1f4f2',
        aliases: []
      },
      {
        skin: false,
        name: 'phone',
        code: '260e-fe0f',
        aliases: [
          'telephone'
        ]
      },
      {
        skin: false,
        name: 'telephone_receiver',
        code: '1f4de',
        aliases: []
      },
      {
        skin: false,
        name: 'pager',
        code: '1f4df',
        aliases: []
      },
      {
        skin: false,
        name: 'fax',
        code: '1f4e0',
        aliases: []
      },
      {
        skin: false,
        name: 'battery',
        code: '1f50b',
        aliases: []
      },
      {
        skin: false,
        name: 'electric_plug',
        code: '1f50c',
        aliases: []
      },
      {
        skin: false,
        name: 'computer',
        code: '1f4bb',
        aliases: []
      },
      {
        skin: false,
        name: 'desktop_computer',
        code: '1f5a5-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'printer',
        code: '1f5a8-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'keyboard',
        code: '2328-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'three_button_mouse',
        code: '1f5b1-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'trackball',
        code: '1f5b2-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'minidisc',
        code: '1f4bd',
        aliases: []
      },
      {
        skin: false,
        name: 'floppy_disk',
        code: '1f4be',
        aliases: []
      },
      {
        skin: false,
        name: 'cd',
        code: '1f4bf',
        aliases: []
      },
      {
        skin: false,
        name: 'dvd',
        code: '1f4c0',
        aliases: []
      },
      {
        skin: false,
        name: 'movie_camera',
        code: '1f3a5',
        aliases: []
      },
      {
        skin: false,
        name: 'film_frames',
        code: '1f39e-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'film_projector',
        code: '1f4fd-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'clapper',
        code: '1f3ac',
        aliases: []
      },
      {
        skin: false,
        name: 'tv',
        code: '1f4fa',
        aliases: []
      },
      {
        skin: false,
        name: 'camera',
        code: '1f4f7',
        aliases: []
      },
      {
        skin: false,
        name: 'camera_with_flash',
        code: '1f4f8',
        aliases: []
      },
      {
        skin: false,
        name: 'video_camera',
        code: '1f4f9',
        aliases: []
      },
      {
        skin: false,
        name: 'vhs',
        code: '1f4fc',
        aliases: []
      },
      {
        skin: false,
        name: 'mag',
        code: '1f50d',
        aliases: []
      },
      {
        skin: false,
        name: 'mag_right',
        code: '1f50e',
        aliases: []
      },
      {
        skin: false,
        name: 'microscope',
        code: '1f52c',
        aliases: []
      },
      {
        skin: false,
        name: 'telescope',
        code: '1f52d',
        aliases: []
      },
      {
        skin: false,
        name: 'satellite_antenna',
        code: '1f4e1',
        aliases: []
      },
      {
        skin: false,
        name: 'candle',
        code: '1f56f-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'bulb',
        code: '1f4a1',
        aliases: []
      },
      {
        skin: false,
        name: 'flashlight',
        code: '1f526',
        aliases: []
      },
      {
        skin: false,
        name: 'izakaya_lantern',
        code: '1f3ee',
        aliases: [
          'lantern'
        ]
      },
      {
        skin: false,
        name: 'notebook_with_decorative_cover',
        code: '1f4d4',
        aliases: []
      },
      {
        skin: false,
        name: 'closed_book',
        code: '1f4d5',
        aliases: []
      },
      {
        skin: false,
        name: 'book',
        code: '1f4d6',
        aliases: [
          'open_book'
        ]
      },
      {
        skin: false,
        name: 'green_book',
        code: '1f4d7',
        aliases: []
      },
      {
        skin: false,
        name: 'blue_book',
        code: '1f4d8',
        aliases: []
      },
      {
        skin: false,
        name: 'orange_book',
        code: '1f4d9',
        aliases: []
      },
      {
        skin: false,
        name: 'books',
        code: '1f4da',
        aliases: []
      },
      {
        skin: false,
        name: 'notebook',
        code: '1f4d3',
        aliases: []
      },
      {
        skin: false,
        name: 'ledger',
        code: '1f4d2',
        aliases: []
      },
      {
        skin: false,
        name: 'page_with_curl',
        code: '1f4c3',
        aliases: []
      },
      {
        skin: false,
        name: 'scroll',
        code: '1f4dc',
        aliases: []
      },
      {
        skin: false,
        name: 'page_facing_up',
        code: '1f4c4',
        aliases: []
      },
      {
        skin: false,
        name: 'newspaper',
        code: '1f4f0',
        aliases: []
      },
      {
        skin: false,
        name: 'rolled_up_newspaper',
        code: '1f5de-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'bookmark_tabs',
        code: '1f4d1',
        aliases: []
      },
      {
        skin: false,
        name: 'bookmark',
        code: '1f516',
        aliases: []
      },
      {
        skin: false,
        name: 'label',
        code: '1f3f7-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'moneybag',
        code: '1f4b0',
        aliases: []
      },
      {
        skin: false,
        name: 'yen',
        code: '1f4b4',
        aliases: []
      },
      {
        skin: false,
        name: 'dollar',
        code: '1f4b5',
        aliases: []
      },
      {
        skin: false,
        name: 'euro',
        code: '1f4b6',
        aliases: []
      },
      {
        skin: false,
        name: 'pound',
        code: '1f4b7',
        aliases: []
      },
      {
        skin: false,
        name: 'money_with_wings',
        code: '1f4b8',
        aliases: []
      },
      {
        skin: false,
        name: 'credit_card',
        code: '1f4b3',
        aliases: []
      },
      {
        skin: false,
        name: 'chart',
        code: '1f4b9',
        aliases: []
      },
      {
        skin: false,
        name: 'currency_exchange',
        code: '1f4b1',
        aliases: []
      },
      {
        skin: false,
        name: 'heavy_dollar_sign',
        code: '1f4b2',
        aliases: []
      },
      {
        skin: false,
        name: 'email',
        code: '2709-fe0f',
        aliases: [
          'envelope'
        ]
      },
      {
        skin: false,
        name: 'e-mail',
        code: '1f4e7',
        aliases: []
      },
      {
        skin: false,
        name: 'incoming_envelope',
        code: '1f4e8',
        aliases: []
      },
      {
        skin: false,
        name: 'envelope_with_arrow',
        code: '1f4e9',
        aliases: []
      },
      {
        skin: false,
        name: 'outbox_tray',
        code: '1f4e4',
        aliases: []
      },
      {
        skin: false,
        name: 'inbox_tray',
        code: '1f4e5',
        aliases: []
      },
      {
        skin: false,
        name: 'package',
        code: '1f4e6',
        aliases: []
      },
      {
        skin: false,
        name: 'mailbox',
        code: '1f4eb',
        aliases: []
      },
      {
        skin: false,
        name: 'mailbox_closed',
        code: '1f4ea',
        aliases: []
      },
      {
        skin: false,
        name: 'mailbox_with_mail',
        code: '1f4ec',
        aliases: []
      },
      {
        skin: false,
        name: 'mailbox_with_no_mail',
        code: '1f4ed',
        aliases: []
      },
      {
        skin: false,
        name: 'postbox',
        code: '1f4ee',
        aliases: []
      },
      {
        skin: false,
        name: 'ballot_box_with_ballot',
        code: '1f5f3-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'pencil2',
        code: '270f-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'black_nib',
        code: '2712-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'lower_left_fountain_pen',
        code: '1f58b-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'lower_left_ballpoint_pen',
        code: '1f58a-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'lower_left_paintbrush',
        code: '1f58c-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'lower_left_crayon',
        code: '1f58d-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'memo',
        code: '1f4dd',
        aliases: [
          'pencil'
        ]
      },
      {
        skin: false,
        name: 'briefcase',
        code: '1f4bc',
        aliases: []
      },
      {
        skin: false,
        name: 'file_folder',
        code: '1f4c1',
        aliases: []
      },
      {
        skin: false,
        name: 'open_file_folder',
        code: '1f4c2',
        aliases: []
      },
      {
        skin: false,
        name: 'card_index_dividers',
        code: '1f5c2-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'date',
        code: '1f4c5',
        aliases: []
      },
      {
        skin: false,
        name: 'calendar',
        code: '1f4c6',
        aliases: []
      },
      {
        skin: false,
        name: 'spiral_note_pad',
        code: '1f5d2-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'spiral_calendar_pad',
        code: '1f5d3-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'card_index',
        code: '1f4c7',
        aliases: []
      },
      {
        skin: false,
        name: 'chart_with_upwards_trend',
        code: '1f4c8',
        aliases: []
      },
      {
        skin: false,
        name: 'chart_with_downwards_trend',
        code: '1f4c9',
        aliases: []
      },
      {
        skin: false,
        name: 'bar_chart',
        code: '1f4ca',
        aliases: []
      },
      {
        skin: false,
        name: 'clipboard',
        code: '1f4cb',
        aliases: []
      },
      {
        skin: false,
        name: 'pushpin',
        code: '1f4cc',
        aliases: []
      },
      {
        skin: false,
        name: 'round_pushpin',
        code: '1f4cd',
        aliases: []
      },
      {
        skin: false,
        name: 'paperclip',
        code: '1f4ce',
        aliases: []
      },
      {
        skin: false,
        name: 'linked_paperclips',
        code: '1f587-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'straight_ruler',
        code: '1f4cf',
        aliases: []
      },
      {
        skin: false,
        name: 'triangular_ruler',
        code: '1f4d0',
        aliases: []
      },
      {
        skin: false,
        name: 'scissors',
        code: '2702-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'card_file_box',
        code: '1f5c3-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'file_cabinet',
        code: '1f5c4-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'wastebasket',
        code: '1f5d1-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'lock',
        code: '1f512',
        aliases: []
      },
      {
        skin: false,
        name: 'unlock',
        code: '1f513',
        aliases: []
      },
      {
        skin: false,
        name: 'lock_with_ink_pen',
        code: '1f50f',
        aliases: []
      },
      {
        skin: false,
        name: 'closed_lock_with_key',
        code: '1f510',
        aliases: []
      },
      {
        skin: false,
        name: 'key',
        code: '1f511',
        aliases: []
      },
      {
        skin: false,
        name: 'old_key',
        code: '1f5dd-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'hammer',
        code: '1f528',
        aliases: []
      },
      {
        skin: false,
        name: 'pick',
        code: '26cf-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'hammer_and_pick',
        code: '2692-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'hammer_and_wrench',
        code: '1f6e0-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'dagger_knife',
        code: '1f5e1-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'crossed_swords',
        code: '2694-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'gun',
        code: '1f52b',
        aliases: []
      },
      {
        skin: false,
        name: 'bow_and_arrow',
        code: '1f3f9',
        aliases: []
      },
      {
        skin: false,
        name: 'shield',
        code: '1f6e1-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'wrench',
        code: '1f527',
        aliases: []
      },
      {
        skin: false,
        name: 'nut_and_bolt',
        code: '1f529',
        aliases: []
      },
      {
        skin: false,
        name: 'gear',
        code: '2699-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'compression',
        code: '1f5dc-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'alembic',
        code: '2697-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'scales',
        code: '2696-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'link',
        code: '1f517',
        aliases: []
      },
      {
        skin: false,
        name: 'chains',
        code: '26d3-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'syringe',
        code: '1f489',
        aliases: []
      },
      {
        skin: false,
        name: 'pill',
        code: '1f48a',
        aliases: []
      },
      {
        skin: false,
        name: 'smoking',
        code: '1f6ac',
        aliases: []
      },
      {
        skin: false,
        name: 'coffin',
        code: '26b0-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'funeral_urn',
        code: '26b1-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'moyai',
        code: '1f5ff',
        aliases: []
      },
      {
        skin: false,
        name: 'oil_drum',
        code: '1f6e2-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'crystal_ball',
        code: '1f52e',
        aliases: []
      },
      {
        skin: false,
        name: 'shopping_trolley',
        code: '1f6d2',
        aliases: []
      },
    ]
  },
  {
    title: 't(Symbols)',
    emojis: [
      {
        skin: false,
        name: 'atm',
        code: '1f3e7',
        aliases: []
      },
      {
        skin: false,
        name: 'put_litter_in_its_place',
        code: '1f6ae',
        aliases: []
      },
      {
        skin: false,
        name: 'potable_water',
        code: '1f6b0',
        aliases: []
      },
      {
        skin: false,
        name: 'wheelchair',
        code: '267f',
        aliases: []
      },
      {
        skin: false,
        name: 'mens',
        code: '1f6b9',
        aliases: []
      },
      {
        skin: false,
        name: 'womens',
        code: '1f6ba',
        aliases: []
      },
      {
        skin: false,
        name: 'restroom',
        code: '1f6bb',
        aliases: []
      },
      {
        skin: false,
        name: 'baby_symbol',
        code: '1f6bc',
        aliases: []
      },
      {
        skin: false,
        name: 'wc',
        code: '1f6be',
        aliases: []
      },
      {
        skin: false,
        name: 'passport_control',
        code: '1f6c2',
        aliases: []
      },
      {
        skin: false,
        name: 'customs',
        code: '1f6c3',
        aliases: []
      },
      {
        skin: false,
        name: 'baggage_claim',
        code: '1f6c4',
        aliases: []
      },
      {
        skin: false,
        name: 'left_luggage',
        code: '1f6c5',
        aliases: []
      },
      {
        skin: false,
        name: 'warning',
        code: '26a0-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'children_crossing',
        code: '1f6b8',
        aliases: []
      },
      {
        skin: false,
        name: 'no_entry',
        code: '26d4',
        aliases: []
      },
      {
        skin: false,
        name: 'no_entry_sign',
        code: '1f6ab',
        aliases: []
      },
      {
        skin: false,
        name: 'no_bicycles',
        code: '1f6b3',
        aliases: []
      },
      {
        skin: false,
        name: 'no_smoking',
        code: '1f6ad',
        aliases: []
      },
      {
        skin: false,
        name: 'do_not_litter',
        code: '1f6af',
        aliases: []
      },
      {
        skin: false,
        name: 'non-potable_water',
        code: '1f6b1',
        aliases: []
      },
      {
        skin: false,
        name: 'no_pedestrians',
        code: '1f6b7',
        aliases: []
      },
      {
        skin: false,
        name: 'no_mobile_phones',
        code: '1f4f5',
        aliases: []
      },
      {
        skin: false,
        name: 'underage',
        code: '1f51e',
        aliases: []
      },
      {
        skin: false,
        name: 'radioactive_sign',
        code: '2622-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'biohazard_sign',
        code: '2623-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'arrow_up',
        code: '2b06-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'arrow_upper_right',
        code: '2197-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'arrow_right',
        code: '27a1-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'arrow_lower_right',
        code: '2198-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'arrow_down',
        code: '2b07-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'arrow_lower_left',
        code: '2199-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'arrow_left',
        code: '2b05-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'arrow_upper_left',
        code: '2196-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'arrow_up_down',
        code: '2195-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'left_right_arrow',
        code: '2194-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'leftwards_arrow_with_hook',
        code: '21a9-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'arrow_right_hook',
        code: '21aa-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'arrow_heading_up',
        code: '2934-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'arrow_heading_down',
        code: '2935-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'arrows_clockwise',
        code: '1f503',
        aliases: []
      },
      {
        skin: false,
        name: 'arrows_counterclockwise',
        code: '1f504',
        aliases: []
      },
      {
        skin: false,
        name: 'back',
        code: '1f519',
        aliases: []
      },
      {
        skin: false,
        name: 'end',
        code: '1f51a',
        aliases: []
      },
      {
        skin: false,
        name: 'on',
        code: '1f51b',
        aliases: []
      },
      {
        skin: false,
        name: 'soon',
        code: '1f51c',
        aliases: []
      },
      {
        skin: false,
        name: 'top',
        code: '1f51d',
        aliases: []
      },
      {
        skin: false,
        name: 'place_of_worship',
        code: '1f6d0',
        aliases: []
      },
      {
        skin: false,
        name: 'atom_symbol',
        code: '269b-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'om_symbol',
        code: '1f549-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'star_of_david',
        code: '2721-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'wheel_of_dharma',
        code: '2638-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'yin_yang',
        code: '262f-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'latin_cross',
        code: '271d-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'orthodox_cross',
        code: '2626-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'star_and_crescent',
        code: '262a-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'peace_symbol',
        code: '262e-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'menorah_with_nine_branches',
        code: '1f54e',
        aliases: []
      },
      {
        skin: false,
        name: 'six_pointed_star',
        code: '1f52f',
        aliases: []
      },
      {
        skin: false,
        name: 'aries',
        code: '2648',
        aliases: []
      },
      {
        skin: false,
        name: 'taurus',
        code: '2649',
        aliases: []
      },
      {
        skin: false,
        name: 'gemini',
        code: '264a',
        aliases: []
      },
      {
        skin: false,
        name: 'cancer',
        code: '264b',
        aliases: []
      },
      {
        skin: false,
        name: 'leo',
        code: '264c',
        aliases: []
      },
      {
        skin: false,
        name: 'virgo',
        code: '264d',
        aliases: []
      },
      {
        skin: false,
        name: 'libra',
        code: '264e',
        aliases: []
      },
      {
        skin: false,
        name: 'scorpius',
        code: '264f',
        aliases: []
      },
      {
        skin: false,
        name: 'sagittarius',
        code: '2650',
        aliases: []
      },
      {
        skin: false,
        name: 'capricorn',
        code: '2651',
        aliases: []
      },
      {
        skin: false,
        name: 'aquarius',
        code: '2652',
        aliases: []
      },
      {
        skin: false,
        name: 'pisces',
        code: '2653',
        aliases: []
      },
      {
        skin: false,
        name: 'ophiuchus',
        code: '26ce',
        aliases: []
      },
      {
        skin: false,
        name: 'twisted_rightwards_arrows',
        code: '1f500',
        aliases: []
      },
      {
        skin: false,
        name: 'repeat',
        code: '1f501',
        aliases: []
      },
      {
        skin: false,
        name: 'repeat_one',
        code: '1f502',
        aliases: []
      },
      {
        skin: false,
        name: 'arrow_forward',
        code: '25b6-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'fast_forward',
        code: '23e9',
        aliases: []
      },
      {
        skin: false,
        name: 'black_right_pointing_double_triangle_with_vertical_bar',
        code: '23ed-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'black_right_pointing_triangle_with_double_vertical_bar',
        code: '23ef-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'arrow_backward',
        code: '25c0-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'rewind',
        code: '23ea',
        aliases: []
      },
      {
        skin: false,
        name: 'black_left_pointing_double_triangle_with_vertical_bar',
        code: '23ee-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'arrow_up_small',
        code: '1f53c',
        aliases: []
      },
      {
        skin: false,
        name: 'arrow_double_up',
        code: '23eb',
        aliases: []
      },
      {
        skin: false,
        name: 'arrow_down_small',
        code: '1f53d',
        aliases: []
      },
      {
        skin: false,
        name: 'arrow_double_down',
        code: '23ec',
        aliases: []
      },
      {
        skin: false,
        name: 'double_vertical_bar',
        code: '23f8-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'black_square_for_stop',
        code: '23f9-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'black_circle_for_record',
        code: '23fa-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'eject',
        code: '23cf-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'cinema',
        code: '1f3a6',
        aliases: []
      },
      {
        skin: false,
        name: 'low_brightness',
        code: '1f505',
        aliases: []
      },
      {
        skin: false,
        name: 'high_brightness',
        code: '1f506',
        aliases: []
      },
      {
        skin: false,
        name: 'signal_strength',
        code: '1f4f6',
        aliases: []
      },
      {
        skin: false,
        name: 'vibration_mode',
        code: '1f4f3',
        aliases: []
      },
      {
        skin: false,
        name: 'mobile_phone_off',
        code: '1f4f4',
        aliases: []
      },
      {
        skin: false,
        name: 'female_sign',
        code: '2640-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'male_sign',
        code: '2642-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'medical_symbol',
        code: '2695-fe0f',
        aliases: [
          'staff_of_aesculapius'
        ]
      },
      {
        skin: false,
        name: 'recycle',
        code: '267b-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'fleur_de_lis',
        code: '269c-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'trident',
        code: '1f531',
        aliases: []
      },
      {
        skin: false,
        name: 'name_badge',
        code: '1f4db',
        aliases: []
      },
      {
        skin: false,
        name: 'beginner',
        code: '1f530',
        aliases: []
      },
      {
        skin: false,
        name: 'o',
        code: '2b55',
        aliases: []
      },
      {
        skin: false,
        name: 'white_check_mark',
        code: '2705',
        aliases: []
      },
      {
        skin: false,
        name: 'ballot_box_with_check',
        code: '2611-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'heavy_check_mark',
        code: '2714-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'heavy_multiplication_x',
        code: '2716-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'x',
        code: '274c',
        aliases: []
      },
      {
        skin: false,
        name: 'negative_squared_cross_mark',
        code: '274e',
        aliases: []
      },
      {
        skin: false,
        name: 'heavy_plus_sign',
        code: '2795',
        aliases: []
      },
      {
        skin: false,
        name: 'heavy_minus_sign',
        code: '2796',
        aliases: []
      },
      {
        skin: false,
        name: 'heavy_division_sign',
        code: '2797',
        aliases: []
      },
      {
        skin: false,
        name: 'curly_loop',
        code: '27b0',
        aliases: []
      },
      {
        skin: false,
        name: 'loop',
        code: '27bf',
        aliases: []
      },
      {
        skin: false,
        name: 'part_alternation_mark',
        code: '303d-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'eight_spoked_asterisk',
        code: '2733-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'eight_pointed_black_star',
        code: '2734-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'sparkle',
        code: '2747-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'bangbang',
        code: '203c-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'interrobang',
        code: '2049-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'question',
        code: '2753',
        aliases: []
      },
      {
        skin: false,
        name: 'grey_question',
        code: '2754',
        aliases: []
      },
      {
        skin: false,
        name: 'grey_exclamation',
        code: '2755',
        aliases: []
      },
      {
        skin: false,
        name: 'exclamation',
        code: '2757',
        aliases: [
          'heavy_exclamation_mark'
        ]
      },
      {
        skin: false,
        name: 'wavy_dash',
        code: '3030-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'copyright',
        code: '00a9-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'registered',
        code: '00ae-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'tm',
        code: '2122-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'hash',
        code: '0023-fe0f-20e3',
        aliases: []
      },
      {
        skin: false,
        name: 'keycap_star',
        code: '002a-fe0f-20e3',
        aliases: []
      },
      {
        skin: false,
        name: 'zero',
        code: '0030-fe0f-20e3',
        aliases: []
      },
      {
        skin: false,
        name: 'one',
        code: '0031-fe0f-20e3',
        aliases: []
      },
      {
        skin: false,
        name: 'two',
        code: '0032-fe0f-20e3',
        aliases: []
      },
      {
        skin: false,
        name: 'three',
        code: '0033-fe0f-20e3',
        aliases: []
      },
      {
        skin: false,
        name: 'four',
        code: '0034-fe0f-20e3',
        aliases: []
      },
      {
        skin: false,
        name: 'five',
        code: '0035-fe0f-20e3',
        aliases: []
      },
      {
        skin: false,
        name: 'six',
        code: '0036-fe0f-20e3',
        aliases: []
      },
      {
        skin: false,
        name: 'seven',
        code: '0037-fe0f-20e3',
        aliases: []
      },
      {
        skin: false,
        name: 'eight',
        code: '0038-fe0f-20e3',
        aliases: []
      },
      {
        skin: false,
        name: 'nine',
        code: '0039-fe0f-20e3',
        aliases: []
      },
      {
        skin: false,
        name: 'keycap_ten',
        code: '1f51f',
        aliases: []
      },
      {
        skin: false,
        name: '100',
        code: '1f4af',
        aliases: []
      },
      {
        skin: false,
        name: 'capital_abcd',
        code: '1f520',
        aliases: []
      },
      {
        skin: false,
        name: 'abcd',
        code: '1f521',
        aliases: []
      },
      {
        skin: false,
        name: '1234',
        code: '1f522',
        aliases: []
      },
      {
        skin: false,
        name: 'symbols',
        code: '1f523',
        aliases: []
      },
      {
        skin: false,
        name: 'abc',
        code: '1f524',
        aliases: []
      },
      {
        skin: false,
        name: 'a',
        code: '1f170-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'ab',
        code: '1f18e',
        aliases: []
      },
      {
        skin: false,
        name: 'b',
        code: '1f171-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'cl',
        code: '1f191',
        aliases: []
      },
      {
        skin: false,
        name: 'cool',
        code: '1f192',
        aliases: []
      },
      {
        skin: false,
        name: 'free',
        code: '1f193',
        aliases: []
      },
      {
        skin: false,
        name: 'information_source',
        code: '2139-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'id',
        code: '1f194',
        aliases: []
      },
      {
        skin: false,
        name: 'm',
        code: '24c2-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'new',
        code: '1f195',
        aliases: []
      },
      {
        skin: false,
        name: 'ng',
        code: '1f196',
        aliases: []
      },
      {
        skin: false,
        name: 'o2',
        code: '1f17e-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'ok',
        code: '1f197',
        aliases: []
      },
      {
        skin: false,
        name: 'parking',
        code: '1f17f-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'sos',
        code: '1f198',
        aliases: []
      },
      {
        skin: false,
        name: 'up',
        code: '1f199',
        aliases: []
      },
      {
        skin: false,
        name: 'vs',
        code: '1f19a',
        aliases: []
      },
      {
        skin: false,
        name: 'koko',
        code: '1f201',
        aliases: []
      },
      {
        skin: false,
        name: 'sa',
        code: '1f202-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'u6708',
        code: '1f237-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'u6709',
        code: '1f236',
        aliases: []
      },
      {
        skin: false,
        name: 'u6307',
        code: '1f22f',
        aliases: []
      },
      {
        skin: false,
        name: 'ideograph_advantage',
        code: '1f250',
        aliases: []
      },
      {
        skin: false,
        name: 'u5272',
        code: '1f239',
        aliases: []
      },
      {
        skin: false,
        name: 'u7121',
        code: '1f21a',
        aliases: []
      },
      {
        skin: false,
        name: 'u7981',
        code: '1f232',
        aliases: []
      },
      {
        skin: false,
        name: 'accept',
        code: '1f251',
        aliases: []
      },
      {
        skin: false,
        name: 'u7533',
        code: '1f238',
        aliases: []
      },
      {
        skin: false,
        name: 'u5408',
        code: '1f234',
        aliases: []
      },
      {
        skin: false,
        name: 'u7a7a',
        code: '1f233',
        aliases: []
      },
      {
        skin: false,
        name: 'congratulations',
        code: '3297-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'secret',
        code: '3299-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'u55b6',
        code: '1f23a',
        aliases: []
      },
      {
        skin: false,
        name: 'u6e80',
        code: '1f235',
        aliases: []
      },
      {
        skin: false,
        name: 'black_small_square',
        code: '25aa-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'white_small_square',
        code: '25ab-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'white_medium_square',
        code: '25fb-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'black_medium_square',
        code: '25fc-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'white_medium_small_square',
        code: '25fd',
        aliases: []
      },
      {
        skin: false,
        name: 'black_medium_small_square',
        code: '25fe',
        aliases: []
      },
      {
        skin: false,
        name: 'black_large_square',
        code: '2b1b',
        aliases: []
      },
      {
        skin: false,
        name: 'white_large_square',
        code: '2b1c',
        aliases: []
      },
      {
        skin: false,
        name: 'large_orange_diamond',
        code: '1f536',
        aliases: []
      },
      {
        skin: false,
        name: 'large_blue_diamond',
        code: '1f537',
        aliases: []
      },
      {
        skin: false,
        name: 'small_orange_diamond',
        code: '1f538',
        aliases: []
      },
      {
        skin: false,
        name: 'small_blue_diamond',
        code: '1f539',
        aliases: []
      },
      {
        skin: false,
        name: 'small_red_triangle',
        code: '1f53a',
        aliases: []
      },
      {
        skin: false,
        name: 'small_red_triangle_down',
        code: '1f53b',
        aliases: []
      },
      {
        skin: false,
        name: 'diamond_shape_with_a_dot_inside',
        code: '1f4a0',
        aliases: []
      },
      {
        skin: false,
        name: 'radio_button',
        code: '1f518',
        aliases: []
      },
      {
        skin: false,
        name: 'black_square_button',
        code: '1f532',
        aliases: []
      },
      {
        skin: false,
        name: 'white_square_button',
        code: '1f533',
        aliases: []
      },
      {
        skin: false,
        name: 'white_circle',
        code: '26aa',
        aliases: []
      },
      {
        skin: false,
        name: 'black_circle',
        code: '26ab',
        aliases: []
      },
      {
        skin: false,
        name: 'red_circle',
        code: '1f534',
        aliases: []
      },
      {
        skin: false,
        name: 'large_blue_circle',
        code: '1f535',
        aliases: []
      },
    ]
  },
  {
    title: 't(Flags)',
    emojis: [
      {
        skin: false,
        name: 'checkered_flag',
        code: '1f3c1',
        aliases: []
      },
      {
        skin: false,
        name: 'triangular_flag_on_post',
        code: '1f6a9',
        aliases: []
      },
      {
        skin: false,
        name: 'crossed_flags',
        code: '1f38c',
        aliases: []
      },
      {
        skin: false,
        name: 'waving_black_flag',
        code: '1f3f4',
        aliases: []
      },
      {
        skin: false,
        name: 'waving_white_flag',
        code: '1f3f3-fe0f',
        aliases: []
      },
      {
        skin: false,
        name: 'rainbow-flag',
        code: '1f3f3-fe0f-200d-1f308',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ac',
        code: '1f1e6-1f1e8',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ad',
        code: '1f1e6-1f1e9',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ae',
        code: '1f1e6-1f1ea',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-af',
        code: '1f1e6-1f1eb',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ag',
        code: '1f1e6-1f1ec',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ai',
        code: '1f1e6-1f1ee',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-al',
        code: '1f1e6-1f1f1',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-am',
        code: '1f1e6-1f1f2',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ao',
        code: '1f1e6-1f1f4',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-aq',
        code: '1f1e6-1f1f6',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ar',
        code: '1f1e6-1f1f7',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-as',
        code: '1f1e6-1f1f8',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-at',
        code: '1f1e6-1f1f9',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-au',
        code: '1f1e6-1f1fa',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-aw',
        code: '1f1e6-1f1fc',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ax',
        code: '1f1e6-1f1fd',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-az',
        code: '1f1e6-1f1ff',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ba',
        code: '1f1e7-1f1e6',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-bb',
        code: '1f1e7-1f1e7',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-bd',
        code: '1f1e7-1f1e9',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-be',
        code: '1f1e7-1f1ea',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-bf',
        code: '1f1e7-1f1eb',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-bg',
        code: '1f1e7-1f1ec',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-bh',
        code: '1f1e7-1f1ed',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-bi',
        code: '1f1e7-1f1ee',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-bj',
        code: '1f1e7-1f1ef',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-bl',
        code: '1f1e7-1f1f1',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-bm',
        code: '1f1e7-1f1f2',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-bn',
        code: '1f1e7-1f1f3',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-bo',
        code: '1f1e7-1f1f4',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-bq',
        code: '1f1e7-1f1f6',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-br',
        code: '1f1e7-1f1f7',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-bs',
        code: '1f1e7-1f1f8',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-bt',
        code: '1f1e7-1f1f9',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-bv',
        code: '1f1e7-1f1fb',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-bw',
        code: '1f1e7-1f1fc',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-by',
        code: '1f1e7-1f1fe',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-bz',
        code: '1f1e7-1f1ff',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ca',
        code: '1f1e8-1f1e6',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-cc',
        code: '1f1e8-1f1e8',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-cd',
        code: '1f1e8-1f1e9',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-cf',
        code: '1f1e8-1f1eb',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-cg',
        code: '1f1e8-1f1ec',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ch',
        code: '1f1e8-1f1ed',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ci',
        code: '1f1e8-1f1ee',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ck',
        code: '1f1e8-1f1f0',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-cl',
        code: '1f1e8-1f1f1',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-cm',
        code: '1f1e8-1f1f2',
        aliases: []
      },
      {
        skin: false,
        name: 'cn',
        code: '1f1e8-1f1f3',
        aliases: [
          'flag-cn'
        ]
      },
      {
        skin: false,
        name: 'flag-co',
        code: '1f1e8-1f1f4',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-cp',
        code: '1f1e8-1f1f5',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-cr',
        code: '1f1e8-1f1f7',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-cu',
        code: '1f1e8-1f1fa',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-cv',
        code: '1f1e8-1f1fb',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-cw',
        code: '1f1e8-1f1fc',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-cx',
        code: '1f1e8-1f1fd',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-cy',
        code: '1f1e8-1f1fe',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-cz',
        code: '1f1e8-1f1ff',
        aliases: []
      },
      {
        skin: false,
        name: 'de',
        code: '1f1e9-1f1ea',
        aliases: [
          'flag-de'
        ]
      },
      {
        skin: false,
        name: 'flag-dg',
        code: '1f1e9-1f1ec',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-dj',
        code: '1f1e9-1f1ef',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-dk',
        code: '1f1e9-1f1f0',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-dm',
        code: '1f1e9-1f1f2',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-do',
        code: '1f1e9-1f1f4',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-dz',
        code: '1f1e9-1f1ff',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ea',
        code: '1f1ea-1f1e6',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ec',
        code: '1f1ea-1f1e8',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ee',
        code: '1f1ea-1f1ea',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-eg',
        code: '1f1ea-1f1ec',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-eh',
        code: '1f1ea-1f1ed',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-er',
        code: '1f1ea-1f1f7',
        aliases: []
      },
      {
        skin: false,
        name: 'es',
        code: '1f1ea-1f1f8',
        aliases: [
          'flag-es'
        ]
      },
      {
        skin: false,
        name: 'flag-et',
        code: '1f1ea-1f1f9',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-eu',
        code: '1f1ea-1f1fa',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-fi',
        code: '1f1eb-1f1ee',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-fj',
        code: '1f1eb-1f1ef',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-fk',
        code: '1f1eb-1f1f0',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-fm',
        code: '1f1eb-1f1f2',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-fo',
        code: '1f1eb-1f1f4',
        aliases: []
      },
      {
        skin: false,
        name: 'fr',
        code: '1f1eb-1f1f7',
        aliases: [
          'flag-fr'
        ]
      },
      {
        skin: false,
        name: 'flag-ga',
        code: '1f1ec-1f1e6',
        aliases: []
      },
      {
        skin: false,
        name: 'gb',
        code: '1f1ec-1f1e7',
        aliases: [
          'uk',
          'flag-gb'
        ]
      },
      {
        skin: false,
        name: 'flag-gd',
        code: '1f1ec-1f1e9',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ge',
        code: '1f1ec-1f1ea',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-gf',
        code: '1f1ec-1f1eb',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-gg',
        code: '1f1ec-1f1ec',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-gh',
        code: '1f1ec-1f1ed',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-gi',
        code: '1f1ec-1f1ee',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-gl',
        code: '1f1ec-1f1f1',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-gm',
        code: '1f1ec-1f1f2',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-gn',
        code: '1f1ec-1f1f3',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-gp',
        code: '1f1ec-1f1f5',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-gq',
        code: '1f1ec-1f1f6',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-gr',
        code: '1f1ec-1f1f7',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-gs',
        code: '1f1ec-1f1f8',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-gt',
        code: '1f1ec-1f1f9',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-gu',
        code: '1f1ec-1f1fa',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-gw',
        code: '1f1ec-1f1fc',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-gy',
        code: '1f1ec-1f1fe',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-hk',
        code: '1f1ed-1f1f0',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-hm',
        code: '1f1ed-1f1f2',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-hn',
        code: '1f1ed-1f1f3',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-hr',
        code: '1f1ed-1f1f7',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ht',
        code: '1f1ed-1f1f9',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-hu',
        code: '1f1ed-1f1fa',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ic',
        code: '1f1ee-1f1e8',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-id',
        code: '1f1ee-1f1e9',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ie',
        code: '1f1ee-1f1ea',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-il',
        code: '1f1ee-1f1f1',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-im',
        code: '1f1ee-1f1f2',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-in',
        code: '1f1ee-1f1f3',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-io',
        code: '1f1ee-1f1f4',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-iq',
        code: '1f1ee-1f1f6',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ir',
        code: '1f1ee-1f1f7',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-is',
        code: '1f1ee-1f1f8',
        aliases: []
      },
      {
        skin: false,
        name: 'it',
        code: '1f1ee-1f1f9',
        aliases: [
          'flag-it'
        ]
      },
      {
        skin: false,
        name: 'flag-je',
        code: '1f1ef-1f1ea',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-jm',
        code: '1f1ef-1f1f2',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-jo',
        code: '1f1ef-1f1f4',
        aliases: []
      },
      {
        skin: false,
        name: 'jp',
        code: '1f1ef-1f1f5',
        aliases: [
          'flag-jp'
        ]
      },
      {
        skin: false,
        name: 'flag-ke',
        code: '1f1f0-1f1ea',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-kg',
        code: '1f1f0-1f1ec',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-kh',
        code: '1f1f0-1f1ed',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ki',
        code: '1f1f0-1f1ee',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-km',
        code: '1f1f0-1f1f2',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-kn',
        code: '1f1f0-1f1f3',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-kp',
        code: '1f1f0-1f1f5',
        aliases: []
      },
      {
        skin: false,
        name: 'kr',
        code: '1f1f0-1f1f7',
        aliases: [
          'flag-kr'
        ]
      },
      {
        skin: false,
        name: 'flag-kw',
        code: '1f1f0-1f1fc',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ky',
        code: '1f1f0-1f1fe',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-kz',
        code: '1f1f0-1f1ff',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-la',
        code: '1f1f1-1f1e6',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-lb',
        code: '1f1f1-1f1e7',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-lc',
        code: '1f1f1-1f1e8',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-li',
        code: '1f1f1-1f1ee',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-lk',
        code: '1f1f1-1f1f0',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-lr',
        code: '1f1f1-1f1f7',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ls',
        code: '1f1f1-1f1f8',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-lt',
        code: '1f1f1-1f1f9',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-lu',
        code: '1f1f1-1f1fa',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-lv',
        code: '1f1f1-1f1fb',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ly',
        code: '1f1f1-1f1fe',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ma',
        code: '1f1f2-1f1e6',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-mc',
        code: '1f1f2-1f1e8',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-md',
        code: '1f1f2-1f1e9',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-me',
        code: '1f1f2-1f1ea',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-mf',
        code: '1f1f2-1f1eb',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-mg',
        code: '1f1f2-1f1ec',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-mh',
        code: '1f1f2-1f1ed',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-mk',
        code: '1f1f2-1f1f0',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ml',
        code: '1f1f2-1f1f1',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-mm',
        code: '1f1f2-1f1f2',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-mn',
        code: '1f1f2-1f1f3',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-mo',
        code: '1f1f2-1f1f4',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-mp',
        code: '1f1f2-1f1f5',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-mq',
        code: '1f1f2-1f1f6',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-mr',
        code: '1f1f2-1f1f7',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ms',
        code: '1f1f2-1f1f8',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-mt',
        code: '1f1f2-1f1f9',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-mu',
        code: '1f1f2-1f1fa',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-mv',
        code: '1f1f2-1f1fb',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-mw',
        code: '1f1f2-1f1fc',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-mx',
        code: '1f1f2-1f1fd',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-my',
        code: '1f1f2-1f1fe',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-mz',
        code: '1f1f2-1f1ff',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-na',
        code: '1f1f3-1f1e6',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-nc',
        code: '1f1f3-1f1e8',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ne',
        code: '1f1f3-1f1ea',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-nf',
        code: '1f1f3-1f1eb',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ng',
        code: '1f1f3-1f1ec',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ni',
        code: '1f1f3-1f1ee',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-nl',
        code: '1f1f3-1f1f1',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-no',
        code: '1f1f3-1f1f4',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-np',
        code: '1f1f3-1f1f5',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-nr',
        code: '1f1f3-1f1f7',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-nu',
        code: '1f1f3-1f1fa',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-nz',
        code: '1f1f3-1f1ff',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-om',
        code: '1f1f4-1f1f2',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-pa',
        code: '1f1f5-1f1e6',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-pe',
        code: '1f1f5-1f1ea',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-pf',
        code: '1f1f5-1f1eb',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-pg',
        code: '1f1f5-1f1ec',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ph',
        code: '1f1f5-1f1ed',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-pk',
        code: '1f1f5-1f1f0',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-pl',
        code: '1f1f5-1f1f1',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-pm',
        code: '1f1f5-1f1f2',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-pn',
        code: '1f1f5-1f1f3',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-pr',
        code: '1f1f5-1f1f7',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ps',
        code: '1f1f5-1f1f8',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-pt',
        code: '1f1f5-1f1f9',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-pw',
        code: '1f1f5-1f1fc',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-py',
        code: '1f1f5-1f1fe',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-qa',
        code: '1f1f6-1f1e6',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-re',
        code: '1f1f7-1f1ea',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ro',
        code: '1f1f7-1f1f4',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-rs',
        code: '1f1f7-1f1f8',
        aliases: []
      },
      {
        skin: false,
        name: 'ru',
        code: '1f1f7-1f1fa',
        aliases: [
          'flag-ru'
        ]
      },
      {
        skin: false,
        name: 'flag-rw',
        code: '1f1f7-1f1fc',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-sa',
        code: '1f1f8-1f1e6',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-sb',
        code: '1f1f8-1f1e7',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-sc',
        code: '1f1f8-1f1e8',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-sd',
        code: '1f1f8-1f1e9',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-se',
        code: '1f1f8-1f1ea',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-sg',
        code: '1f1f8-1f1ec',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-sh',
        code: '1f1f8-1f1ed',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-si',
        code: '1f1f8-1f1ee',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-sj',
        code: '1f1f8-1f1ef',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-sk',
        code: '1f1f8-1f1f0',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-sl',
        code: '1f1f8-1f1f1',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-sm',
        code: '1f1f8-1f1f2',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-sn',
        code: '1f1f8-1f1f3',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-so',
        code: '1f1f8-1f1f4',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-sr',
        code: '1f1f8-1f1f7',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ss',
        code: '1f1f8-1f1f8',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-st',
        code: '1f1f8-1f1f9',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-sv',
        code: '1f1f8-1f1fb',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-sx',
        code: '1f1f8-1f1fd',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-sy',
        code: '1f1f8-1f1fe',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-sz',
        code: '1f1f8-1f1ff',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ta',
        code: '1f1f9-1f1e6',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-tc',
        code: '1f1f9-1f1e8',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-td',
        code: '1f1f9-1f1e9',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-tf',
        code: '1f1f9-1f1eb',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-tg',
        code: '1f1f9-1f1ec',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-th',
        code: '1f1f9-1f1ed',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-tj',
        code: '1f1f9-1f1ef',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-tk',
        code: '1f1f9-1f1f0',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-tl',
        code: '1f1f9-1f1f1',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-tm',
        code: '1f1f9-1f1f2',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-tn',
        code: '1f1f9-1f1f3',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-to',
        code: '1f1f9-1f1f4',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-tr',
        code: '1f1f9-1f1f7',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-tt',
        code: '1f1f9-1f1f9',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-tv',
        code: '1f1f9-1f1fb',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-tw',
        code: '1f1f9-1f1fc',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-tz',
        code: '1f1f9-1f1ff',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ua',
        code: '1f1fa-1f1e6',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ug',
        code: '1f1fa-1f1ec',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-um',
        code: '1f1fa-1f1f2',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-un',
        code: '1f1fa-1f1f3',
        aliases: []
      },
      {
        skin: false,
        name: 'us',
        code: '1f1fa-1f1f8',
        aliases: [
          'flag-us'
        ]
      },
      {
        skin: false,
        name: 'flag-uy',
        code: '1f1fa-1f1fe',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-uz',
        code: '1f1fa-1f1ff',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-va',
        code: '1f1fb-1f1e6',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-vc',
        code: '1f1fb-1f1e8',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ve',
        code: '1f1fb-1f1ea',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-vg',
        code: '1f1fb-1f1ec',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-vi',
        code: '1f1fb-1f1ee',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-vn',
        code: '1f1fb-1f1f3',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-vu',
        code: '1f1fb-1f1fa',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-wf',
        code: '1f1fc-1f1eb',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ws',
        code: '1f1fc-1f1f8',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-xk',
        code: '1f1fd-1f1f0',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-ye',
        code: '1f1fe-1f1ea',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-yt',
        code: '1f1fe-1f1f9',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-za',
        code: '1f1ff-1f1e6',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-zm',
        code: '1f1ff-1f1f2',
        aliases: []
      },
      {
        skin: false,
        name: 'flag-zw',
        code: '1f1ff-1f1fc',
        aliases: []
      }
    ]
  }
]
export default emojis
